import { Component, OnInit,AfterViewInit, ElementRef, ViewChild,NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,EventEmitter,SimpleChanges} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import {Utils} from '../_util/utils';
import {CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { Table } from 'primeng/table';

declare var $: any;
@Component({
  selector: 'app-complete-temp',
  templateUrl: './complete-temp.component.html',
  styleUrls: ['./complete-temp.component.css']
})
export class CompleteTempComponent implements OnInit {
	itemIndex=0;
	addon:string;
	logoInfo=[];
	userInfo:any;
	userId:string;
	userName="User";
	tempInfo:any;
	r:string;
	types=[];
	templateCols;

	libraries=[];
	libLabels=[];
	slots=[];
	cols1:any[];
	cols2:any[];
	cols3:any[];
	cols4:any[];
	cols5:any[];
	public cols6:any[];
	selectedSlot:any;
	selectedRptType:string;
	selectedType="";
	selectedCover:any;
	selectedHeader:any;
	selectedFooter:any;
	selectedIden="";
	tempName="";
	categories:any[];
	temps:any[];
	sections:any[];
	chosenSec:any[];
	addedSec:any[];
	tempContents:any[];
	contents:any[];	
	frontpages=[];
	appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
	tempAppendices:any;
	tempIndex:number;
	curIndex=[];
	pageIndex=[];
	slotCategories:any[];
	slotTypes:any[];
	groupSlots=[];
	templateSlots=[];
	public expandedRows = {};
	isExpanded=false;
	slotCheckAll=false;
	curTemp:any;
	addedLib=[];
	addedLibs=[];
	libToSlot=false;
	slotToLib=false;
	curLib=[];
	curLibId=[];
	curSlot=[];
	curSlotId=[];
	newSlotLabel="";
	newSlotCat="";
	newSlotType="";
	newSlotMultiple="N";
	newSlotFile={'url':'', 'name':'', 'ext':''};
	newSlotContent="";
	newSlotOp="";
	newSlotOps=[];
	slotTableType=-1;
	tableSlots=[];
	erisSlots=[];
	selSlots=[];
	pdfSlots=[];
	slotGroup='A';
	filteredData:any[];
	otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE'];
	curTableData:any;
	curCostTable:any;
	rowNo=0;
	colNo=0;
	colType=[];
	newLibPara=[];
	addedItem:any;
	addBefore=false;
	addLibWarn=false;
	tableContent=[];
	addLib=false;
	loading=false;
	pdfs=[];
	appOp='O';
	isEven=true;
	allEditor=[];
	selectedCell:any;
	selectedRow:number;
	inputLabels='';
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;	

	public current:any;
	public covers=[];
	public bks=[];
	public others=[];
	public photos=[];
	public logos=[];
	public headers=[];
	public footers=[];
	public uploadedFiles=[];
	public selectedEditor:string;
	public selectIndex:number;
	public selectedImage;
	public selectedInsert=[];
	public logOutFlag=0;
	public convertDocs=[];
	private fileReader: FileReader;
	public pageMargin={'top':'80', 'bottom':"40", 'left':"25", 'right':"25"};
	public portraitSize={'width':'816','height':'1054'};
	public landscapeSize={'width':'1054','height':'816'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1054'}};
	public selectPdi='600';
	public content='';;
	public showLogo=0;
	public rowData;
	public outData:string;
	public uploadType:string;
	public logoUrl="";
	public bimageurl="";
	public currencies=[];
	public multipliers=['Square Feet (Gross)','Square Feet (NRSF)','Units','Beds','Guestrooms','Pads','Spaces','Acreage/Land Size','Room'];
	public pcaOp={'term':'Include','multiplier':"", 'reserve':12, 'decimal':2,'currency':'USD','inflation':'2.5','round':'Round'};
	public pcaLibraries=[];
	public pcaIdentifiers=[];
	public costTables=[];
	public curCost=[];
	public curCostId=[];
	public addedCost=[];
    public filterText="";
	public repairKeys=['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
	public repairCols=['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
	public costCols1=['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Immediate Total','Short Term Total'];
	public costKeys1=['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short'];
	public costCols2=['Recommendation','EUL','EFF AGE','RUL','Year','Cost'];
	public costKeys2=['Item','EUL','EFF','RUL','Year','Total'];	
	addLibShow=false;
	newLib=false;
	dragDisabled=true;
	autoFlag=false;
	curId:string;
	curSec:any;
	cellShow=false;
	curCol:any;
	curCell:any;
	intext=false;
	public uploading=false;
	allRow=false;
	allCol=false;
	pcaType:string;
	acceptType=[];
	//@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild("viewer") viewer: ElementRef;
	@ViewChild('file') file: ElementRef;
	@ViewChild('file1') file1: ElementRef;
	@ViewChild('file3') file3: ElementRef;
	@ViewChild('file4') file4: ElementRef;
	@ViewChild("dt5", { static: false }) public dt5: Table;
  constructor(private location: Location, private titleService :Title, private sanitizer: DomSanitizer, private router: Router,
  public  reportService: ReportService, private zone: NgZone, private cookieService:CookieService,private route: ActivatedRoute,
              ) { 
	router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) { element.scrollIntoView(); }
        }
      }
    });
	
	let id=decodeURI(this.route.snapshot.paramMap.get('id')); 
	if(this.cookieService.getCookie("userID")) {
						this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));//console.log(this.userInfo)
						this.userId = this.cookieService.getCookie("userID");//console.log(this.userId);
						this.userName = this.cookieService.getCookie("userName");//console.log(this.userName);
						this.r=this.cookieService.getCookie("r");//console.log(this.r);
						if(id!='null'){
							let startJson={"PROCEDURE":"gettemplateeditstatus","USER_ID":this.userId,"TEMPLATE_ID":id}
							this.reportService.univeralService(JSON.stringify(startJson)).subscribe(response => {
								//console.log(response);
								if(response.RESPONSE_STATUS=='Y'){
									//if(response.EDIT_TEMPLATE=='Y'){
										this.getAllCover();
										this.getTemplate(id);
										this.getProfile(id);
										this.getAllHeader();
						this.getAllFooter();
						this.getAllBk(parseInt(this.userId));
						this.getLogo();
						this.getSlots();
						this.getSlotPara();
						this.getslotType();
						this.getTableSlots("Table");
						this.getTableSlots("Selection");
						this.getTableSlots("File");
									/*}else{
										this.router.navigate(['template/'+id])
											.then(nav => {
												//console.log(nav); // true if navigation is successful
											}, err => {
												//console.log(err) // when there's an error
											});
									}*/
								}else{
									this.throwError(response);									
								}
							})							
						}else{
							this.router.navigate(['template'])
										
							/*let that=this;
							setTimeout(() => {
								$('#overlay').css('display','none');
							},1000);
							Swal.fire({
								title: 'What would you like to do today?',								
								confirmButtonText: 'Create New Template',
								showLoaderOnConfirm: true,
								showCancelButton: true,
								cancelButtonText: 'Edit a Template',
								//denyButtonText: 'Choose Saved Template',
								//allowOutsideClick:false,
								backdrop:false,
								}).then((result) => {
									if (result.isConfirmed) {
										that.startNew();
										$("#tempModal").modal('show');
									}else if (	result.dismiss === Swal.DismissReason.cancel){
										this.expandcollapse();
									}

							})*/
												
						}		
	} 
	this.contents=[];
	this.acceptType=this.reportService.acceptFileType.split(',');		  
	}
	getSlots(){
		let inputJson={"PROCEDURE":"getslots", "USER_ID":parseInt(this.userId)};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.slots=data.RW_SLOTS;
		})
	}
	getGroupSlots(){
		let inputJson={"PROCEDURE":"getslotsbycategory", "USER_ID":parseInt(this.userId)};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.groupSlots=data.RW_SLOT_CATEGORIES;			
		})
	}
	getSlotPara(){
		let inputJson={"PROCEDURE":"getslotcategories","USER_ID":parseInt(this.userId)};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.slotCategories=data.RW_SLOT_CATEGORIES;			
		})
	}
	getslotType(){
		let inputJson={"PROCEDURE":"getslottypes","CREATE_NEW_RF":"Y"};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.slotTypes=data.RW_SLOT_TYPES;			
		})
	}
	getLibraries(){
		this.loading=true
		this.zone.run(()=>{this.loading=true;})
		let inputJson={"PROCEDURE":"getlibrary", "USER_ID":parseInt(this.userId), "KEYWORD":"", "REPORT_TYPE":"ESA"};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				this.zone.run(()=>{this.loading=false;})
				return										
			}
			this.libraries=data.RW_LIBRARY;
			this.zone.run(()=>{this.loading=false;})
		})
	}
	getLibLabels(){
		let inputJson={"PROCEDURE":"getlibrarylabels","USER_ID":parseInt(this.userId)};//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			//this.libLabels=data.RW_LABELS;
			this.libLabels=[];
			let that=this;			
			data.RW_LABELS.forEach(name => {
				that.libLabels.push({ label: name.LABEL, value: name.LABEL });
			});
		})
	}
	getTableSlots(type){
		let inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":type,"ACTIVE_ONLY":"Y"};
		//console.log(JSON.stringify(inputJson))
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			if(type=='Table'){
				this.erisSlots=data.RW_SLOTS;
			}else if(type=='Selection'){
				this.selSlots=data.RW_SLOTS;
			}else if(type=='File'){
				this.pdfSlots=data.RW_SLOTS;
			}
		})
	}
	getProfile(id){
		let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"TEMPLATE_ID":id};
			//console.log(inputJson);		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			//console.log(response);
			if(response.RESPONSE_STATUS=="Y"){
				if(response.PCA_TABLE_STYLE&&response.PCA_TABLE_STYLE.length>0){
					this.pcaType=response.PCA_TABLE_STYLE;
				}
			}else{
				this.throwError(response);	
			}
		})
			
	}
  ngOnInit(): void {
	 this.titleService.setTitle("Complete-temp");
		let w = Math.floor(Utils.mmToPx(279, this.reportService.dpi)); //console.log(w);
		let h = Math.floor(Utils.mmToPx(216, this.reportService.dpi)); //console.log(h);
//		this.newCover();
		this.cols1 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'KEY', header: 'label', width: '20%' },
			{ field: 'CONTENT', header: 'Content', width: '50%' },
			{ field: 'CATEGORY', header: 'Category', width: '20%' },
			{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols2 = [			
			{ field: 'CATEGORY', header: 'Category', width: '92%' },
			//{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols3 = [			
			{ field: 'KEY', header: 'label', width: '30%' },
			{ field: 'CONTENT', header: 'Content', width: '60%' },		
			{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols4 = [			
			{ field: 'LABELS', header: 'Title', width: '92%' },
			//{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols5 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'ITEM_TITLE', header: 'label', width: '10%' },
			{ field: 'LABELS', header: 'Content', width: '10%' },
			{ field: 'INSTRUCTIONS', header: 'Category', width: '30%' },
			{ field: 'CONTENT', header: '' , width: '50%' },
				
        ];
		this.cols6 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'FILE_NAME', header: 'File Name', width: '40%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
			{ field: 'PROJECT_ID', header: 'Project Name', width: '15%' },
			{ field: 'REPORT_ID', header: 'Report Type ' , width: '14%' },
			{ field: 'USER_ID', header: 'Upload By ' , width: '12%' },
			{ field: 'FILE_ID', header: 'Date ' , width: '8%' },
				
        ];
		this.templateCols=[

			{ field: 'TEMPLATE_TITLE', header: 'Template Name', width: '20%'},
			{ field: 'CATEGORY_NAME', header: 'Template Type', width: '7%'},
			{ field: 'SUBCATEGORY_NAME', header: 'Template Identifier', width: '20%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '10%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '10%'},
			{ field: 'DATE_UPDATED', header: 'Modified Date', width: '10%'},
			{ field: 'STATUS', header: 'Status', width: '5%'},
		
				{field: 'EDIT', header:'Edit', width:"5%"}
		  ]
		$(document).ready(function () {
			$('#tableModal').draggable();
			$('#fileModal').draggable();
			$('#libraryModal').draggable();
			//$('#costLibModal').draggable();			
		});
		if(this.reportService.autoSaveFlag=='Y'){
			this.autoFlag=true;
		}
		if(this.autoFlag){
			this.autoSave();
		}; 
  }
  ngOnChanges(changes: SimpleChanges): void {
      
	}
	ngOnDestroy(): void {
  }
	public onInfo(e){
	  //this.getOrderDetail();
	}
	saveTemplate(){
		//console.log(this.pcaOp);
		//console.log(this.contents);
		let content=JSON.stringify(this.contents);
		let app=JSON.stringify(this.appendices);
		let beforeToc='';
		if(this.frontpages.length>0){
			beforeToc=JSON.stringify(this.frontpages);
		}
		let pdfInfo={'text':this.pdfFname.text, "name":this.pdfFname.name};
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID, "TEMPLATE_TITLE":this.tempInfo.TEMPLATE_TITLE, "TEMPLATE_URL":this.tempInfo.TEMPLATE_URL, "TEMPLATE_DATA":content, "TEMPLATE_TYPE_ID":this.tempInfo.TEMPLATE_TYPE_ID, "COVERPAGE_ID":parseInt(this.selectedCover),"APPENDIX_DATA":app, "HEADER_ID":parseInt(this.selectedHeader),"FOOTER_ID":parseInt(this.selectedFooter),'PCA_DATA':JSON.stringify(this.pcaOp), 'PDF_FILE_NAME':JSON.stringify(pdfInfo), "BEFORE_TOC":JSON.stringify(this.frontpages)};
		//console.log(inputJson);
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
			//console.log(result);
			if(result.RESPONSE_STATUS=='N'){
				this.throwError(result);
				return	
			}
			if(this.autoFlag){
				window.clearInterval(this.saveTimer);			
				this.autoSave();
			};
	 })		
 }

//	startEdit=false;
	public textData(e, id){//console.log(e, id);
	let secIndex=this.getIdIndex(id); //console.log('first',secIndex)
	//console.log('first',this.curIndex)
	/*if(!this.startEdit){
		if(this.curIndex[0]==secIndex[0]){
			this.startEdit=true;
		}
	}
	if(this.startEdit){*/
	let data=this.sanitizer.bypassSecurityTrustHtml(e);
	this.toContentData('text', e, '', secIndex);
	this.toContentData('htmltext', data, '',secIndex);
	let ids=this.getAllSlotId(e); //console.log(ids);
	if(ids&&ids.length>0){
		let all=[];
		for(let slotid of ids){
			let index=this.slots.findIndex(item=>item.SLOT_ID==slotid);
			if(index>-1){
				all.push(this.slots[index]);
				if(this.slots[index].CATEGORY){
					this.addToTemp(this.slots[index],this.slots[index].CATEGORY);
				}
			}
		}
		//console.log(all);
	this.toContentData('slots', all, '',secIndex);
			
	}
		if(this.autoFlag){
			this.saveTemplate();
		}
	//}
  }
  
	getAllCover(){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":parseInt(this.userId)};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.covers=data.RW_COVERPAGES;
		})
	}
	getAllHeader(){
		let inputJson={"PROCEDURE":"getallheaders", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.headers=data.RW_HEADERS;
		})
	}
	getAllFooter(){
		let inputJson={"PROCEDURE":"getallfooters", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.footers=data.RW_FOOTERS;
		})
	}
	getAllBk(id){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"BKIMAGE"}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.bks=data.RW_UPLOAD_FILES;
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"IMAGE"}
		//console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.others=data.RW_UPLOAD_FILES;
		})
	} 
	private getLogo(){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			this.logoInfo=data;		
			this.logos=data.RW_UPLOAD_FILES;
		})
	} 
	getTemplateHistory(){
		//console.log("this.tempInfo",this.tempInfo)
		this.getAllTempByTypeID(this.tempInfo.TEMPLATE_ID);
		let inputJson={"PROCEDURE":"gettemplatehistory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response);
				
				return										
			}
			this.tempInfo.RW_TEMPLATE_HISTORY=response.RW_TEMPLATE_HISTORY;
		})
	}
	typeList=[];
	getAllTempByTypeID( typeID) {
		let inputJson={"PROCEDURE":"getreportlistbytemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":typeID};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log("getAllTempByTypeID",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			for (let obj of data.RW_REPORTS) {
				typeIdTemplates.push(obj);
			}
			this.typeList2=typeIdTemplates;//console.log(typeIdTemplates);
			this.typeList=this.typeList2;
		});
		
		
	}
	getCostLib(libs?){
		this.filterText="";
		//this.pcaLibraries=[];
		if(this.pcaLibraries.length==0){
			let inputJson3={"PROCEDURE":"getpcacostlibrary","USER_ID":parseInt(this.userId)};
				//let inputJson3={"PROCEDURE":"getpcacostlibrary","USER_ID":parseInt(this.userId),"IDENTIFIER":"ADA Accessibility","KEYWORD":""};
				this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(response => {
					//console.log(response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response);
						
						return										
					}
					this.pcaLibraries=response.RW_PCA_COST_LIBRARY; ////console.log(this.pcaLibraries);
						setTimeout(() => {
							this.dt5.reset();
						},10);
				})
				let inputJson4={"PROCEDURE":"GetCostLibraryIdentifier", "USER_ID":parseInt(this.userId)};
				this.reportService.univeralService(JSON.stringify(inputJson4)).subscribe(response => {
					//console.log(response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response);
						
						return										
					}
					let items=response.RW_COST_LIBRARY_IDENTIFIERS; ////console.log(this.pcaIdentifiers);
					for(let item of items){
						this.pcaIdentifiers.push(item.IDENTIFIER);
					}
				})
		}else{
			setTimeout(() => {
				this.dt5.reset();
						},10);
		}
				if(libs){
					this.addedCost=libs;
					this.curCost=[];
					this.curCostId=[];	
				}else{
					this.addedCost=[];
				}
	}
	getTemplate(id){
		$('#overlay').css('display','block');
		let inputJson={"PROCEDURE":"gettemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		//console.log(inputJson);
		this.current=id;
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response);
				
				return										
			}
			if(response.TEMPLATE_DATA&&response.TEMPLATE_DATA.length>0){
				this.contents=JSON.parse(response.TEMPLATE_DATA);//console.log('contents', this.contents)
			}
			this.curIndex=[this.addon,this.addon,this.addon];
			this.generateSeq();
			this.getTemplateSlots(response.TEMPLATE_ID);


			this.tempInfo=response;
			this.getTemplateHistory()
			if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='Y'){
				this.getCostLib();
			}
			if(response.COVERPAGE&&response.COVERPAGE.length>0){
				this.selectedCover=response.COVERPAGE[0];//.COVERPAGE_ID;
			}
			if(response.HEADER&&response.HEADER.length>0){
				this.selectedHeader=response.HEADER[0];//.HEADERFOOTER_ID;
			}
			if(response.FOOTER&&response.FOOTER.length>0){
				this.selectedFooter=response.FOOTER[0];//.HEADERFOOTER_ID;
			}
			if(response.BEFORE_TOC&&response.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(response.BEFORE_TOC); //console.log('front', this.frontpages)
			}
			if(response.PDF_FILE_NAME&&response.PDF_FILE_NAME.length>0){
				this.pdfFname=JSON.parse(response.PDF_FILE_NAME);//console.log(this.pdfFname)
			}			
			this.titleService.setTitle("Complete-temp"+' - '+response.TEMPLATE_TITLE);
			if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(response.APPENDIX_DATA); //console.log(this.appendices)
			}
			if(response.TEMPLATE_TYPE&&response.TEMPLATE_TYPE[0].TEMPLATE_TYPE_ID>-1){
				let inputJson1={"PROCEDURE":"gettemplatetypeappendix","USER_ID":parseInt(this.userId),"TEMPLATE_TYPE_ID":response.TEMPLATE_TYPE[0].TEMPLATE_TYPE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson1)).subscribe(response => {
					////console.log(response);
					if (JSON.parse(response).RESPONSE_STATUS=='N') {
						this.throwError(JSON.parse(response));
						
						return										
					}
					let info=JSON.parse(response).TEMPLATE_APPENDIX;////console.log(info);
					if(info.length>0){
						this.tempAppendices=JSON.parse(info).TEMPLATE_APPENDIX[0];//console.log(this.tempAppendices);				
					}
				})
			}
			this.location.go('/complete-temp/'+id.toString());
			$('#overlay').css('display','none');
		})
				
	}
	getTemplateSlots(id){
		let tempJson={"PROCEDURE":"getslotsbytemplatecategory", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		//console.log(tempJson);
		this.reportService.univeralService(JSON.stringify(tempJson)).subscribe(response => {
			//console.log(response);//templateSlots
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response);
				return										
			}
			this.groupSlots=response.RW_SLOT_CATEGORIES;
			this.curTemp=response;		
		})
	}
	
	/*updateTmp(type){
		let inputJson:any
		if(type=="cover"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"COVERPAGE_ID":parseInt(this.selectedCover)};
		}else if(type=="header"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"HEADER_ID":parseInt(this.selectedHeader)};
		}else if(type=="footer"){
			inputJson = {"PROCEDURE":"updatetemplate","USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"FOOTER_ID":parseInt(this.selectedFooter)};
		}else{
			
		}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			//console.log(response);
			
		})
	}*/
	/*selectCover(c){
		//console.log("select cover");
		let id=c.COVERPAGE_ID;
		//this.getCover(id);
		this.getCoverPage(id);
	}
	newCover(){
		this.content='';//'<figure class="image image_resized" style="width:22.65%;"><img src="'+this.logoUrl+'"></figure>';
		this.savedData={'bk':this.bimageurl,'docs':[''],'ht':[{'cStyle': "",
			'eData': ' ',//'<figure class="image image_resized" style="width:22.65%;"><img src="'+this.logoUrl+'"></figure>',
			'index': 0}]};
		this.bimageurl='';
		this.docs=[this.savedData.ht[0].eData];
		//this.docs=['<figure class="image image_resized" style="width:29.93%;"><img src="https://erisservice.ecologeris.com/exreport/test/cbkimage/Kcar4LV7Jv4RlA47mEwk6MslomXNlv_x3_white.png"></figure>'];

	}*/
	/*getCoverData(){
		let that=this;
		let styleArray=[];
		const nodes = this.viewer.nativeElement.querySelectorAll('div.comp');//console.log(nodes)
		const nodes1 = this.viewer.nativeElement.querySelectorAll('div.ckContainer');//console.log(nodes1)
		let html='';
		nodes1.forEach(node => {
          //html += `${node.innerHTML}`;
		  let item=node.style.cssText;//console.log(item)
			styleArray.push(item);
        });
		let compArray=[];
		let compStyles=[];
		nodes.forEach(node => {
         	compArray.push(node.innerHTML);
			compStyles.push(node.style.cssText);
        });
		//console.log(html);

		//console.log(compArray);
		//console.log(compStyles);
		let hcontent1=[];
		const nodes2 = this.viewer.nativeElement.querySelectorAll('div.cktest');//console.log(nodes2)
		let i=0;
		nodes2.forEach(node => {//console.log($(node).hasClass('comp'));
			
         	if($(node).hasClass('comp')){//console.log(node)
				hcontent1.push({'hData':node.innerHTML,'hstyle':node.style.cssText});				
			}else if($(node).hasClass('ckContainer')){//console.log(node)
				hcontent1.push({'eData':this.docs[i], 'cStyle':styleArray[i], 'index':i})
				i++;
			}
			
        });
		//console.log(hcontent1);
		/*let p1=this.locations('<div class="ckContainer"',this.rowData); //console.log(p1.length);
		let p2=this.locations('app-paragraph>',this.rowData); //console.log(p2);
		let hcontent=[];
		
		for(let i=0; i<p1.length; i++){//console.log(i);
			if(i==0){//console.log(i)
				hcontent.push({'hData':this.rowData.substring(0, [i])});
				hcontent.push({'eData':this.docs[i], 'cStyle':styleArray[i], 'index':i})
			}else{//console.log(p2[i-1]+14);//console.log(p1[i]);
				//hcontent.push({'hData':this.rowData.substring((p2[i-1]+14),p1[i]), 'cStyle':styleArray[i]});
				hcontent.push({'hData':this.rowData.substring((p2[i-1]+20),p1[i])});
				hcontent.push({'eData':this.docs[i], 'cStyle':styleArray[i], 'index':i})
			}
		}
		
		//hcontent.push(this.rowData.substring(p2[p1.length-1]+14));
		hcontent.push({'hData':this.rowData.substring(p2[p1.length-1]+20)});	
		//console.log(hcontent);
		let compIndex=[];
		for(let i=0; i<hcontent.length; i++){
			if(hcontent[i].hData){
				compIndex.push(i);
			}
			
		}
		//console.log(compIndex);
		for(let i=0; i<compArray.length; i++){
			hcontent[compIndex[i]]={'hData':compArray[i],'hstyle':compStyles[i]}
		}
		//console.log(hcontent);
		//this.savedData={'ht':hcontent,'bk':'https://erisservice7.ecologeris.com/exmobile/test/20302200002/da0c66f27f9947cf8cd6f76ff71103c7.jpg'};
		this.outData=JSON.stringify({'ht':hcontent1,'bk':this.bimageurl,'docs':this.docs, 'margin':this.pageMargin, 'page':this.selectpage});
		////console.log(this.htmlStr);
		//console.log(this.outData);
	}*/

  private locations(substring,string){
  var a=[],i=-1;
  while((i=string.indexOf(substring,i+1)) >= 0) a.push(i);
  return a;
}
	public preview(){
			setTimeout(() => {
			this.generatePdf();
		},500);
	}
	private generatePdf(){
		//console.log(this.reportService.sources)
		let html='';
		if(this.selectpage.type=='portrait'){
			html = this.reportService.a4Portrait;
		}else if(this.selectpage.type=='landscape'){
			html = this.reportService.a4Landscape;
		}
		//console.log(html)
		//let html = this.reportService.a4Portrait;
		html += `<div class="page-after">`;
		//this.rowData=this.htmlStr1;
		this.rowData=this.viewer.nativeElement.innerHTML;
		////console.log(this.rowData);
		let hi=(1054-parseInt(this.pageMargin.top)-parseInt(this.pageMargin.bottom)).toString()+'px';
		html +=`<div style="height:`+hi+`; margin:0; padding:`+this.pageMargin.top+'px '+this.pageMargin.right+'px '+this.pageMargin.bottom+'px '+this.pageMargin.left+'px'+`; background: url('`+this.bimageurl+`');background-repeat: no-repeat;background-size: cover; margin:0">`
		
		//this.rowData=this.viewer.nativeElement.innerHTML;////console.log(this.rowData);
		let p1=this.locations('<app-paragraph',this.rowData); //console.log(p1.length);
		let p2=this.locations('app-paragraph>',this.rowData); //console.log(p2);
		////console.log(this.docs);
		//console.log(this.convertDocs);
		
		for(let i=0; i<p1.length; i++){//console.log(i);
			if(i==0){
				html+=this.rowData.substring(0,p1[i]);
				//html+=this.docs[i]
				html+=this.convertDocs[i]
			}else{//console.log(p2[i-1]+14);//console.log(p1[i]);
				html+=this.rowData.substring((p2[i-1]+14),p1[i]);
				//html+=this.docs[i]
				html+=this.convertDocs[i]
			}
		}
		html+=this.rowData.substring(p2[p1.length-1]+14); //console.log(html)
	    html += `</div></div>`;
		html += this.reportService.tagEnd;
		/*this.reportService.generatePdf(btoa(html), this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi).subscribe((result) => {
            //generatePdf(htmlc: string, r: string, t: string, cid: string, psize: string, orient: string): Observable<Generator> { //console.log({ htmlc, r, t, cid, psize, orient })
  
			//console.log(result)
			jdata: null
		if((result.status=="OK")&&(result.rurl.length>0)){
			window.open(result.rurl, '_blank');
		}
	  })*/
	  
	}
	public upload(type?) {
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			this.file.nativeElement.click();
		}else if(this.uploadType=='FILE'){
			this.appOp='U';
			this.file1.nativeElement.click();
		}else if(this.uploadType=='slot'){
			this.file3.nativeElement.click();
		}
	}

	public uploadImage() {
	let that=this;
	this.uploadFiles=0;
		this.uploadNo=0;
    //const file = this.file.nativeElement.files[0];
	const files = this.file.nativeElement.files; //console.log(files);
    //this.file.nativeElement.value = null;
    if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){
      //this.file.nativeElement.value = null;
      const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
			return;
		}
    }
    for (let file of files)  //for multiple files
    {
		
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
			if(that.uploadType=='BKIMAGE'){//console.log('bk image');
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='PHOTO'){//console.log('report image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='IMAGE'){//console.log('other image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='LOGO'){//console.log('LOGO image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}
			//console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		}
  }
  
	/*selectImg(bk){
		//console.log(bk);
		this.selectedImage=bk;
		this.selectedContainer.src=bk.BKIMAGE_URL;
		//console.log(this.savedData.ht);
		const nodes = this.viewer.nativeElement.querySelectorAll('div.comp');//console.log(nodes)
		const nodes1 = this.viewer.nativeElement.querySelectorAll('div.ckContainer');//console.log(nodes1)
		let html='';
		nodes.forEach(node => {
          html += `${node.innerHTML}`;
        });
		//console.log(html);
	}
	toImage(e){//console.log($(event.target));
		if($(event.target)[0].tagName=="IMG"){
			$('#imgModal').modal('show');
			this.selectedContainer=$(event.target)[0];
			this.selectedImage=null;
		}
	}
	
	public selectInsert(bk){
		////console.log(bk);
		this.selectedInsert=bk;
	let content='<figure class="image image_resized" style="width:30%;"><img src="'+bk.BKIMAGE_URL+'"></figure>';
		//console.log(content)
	
	}
	public chooseBackground(){
		if(this.savedData){
		$('#bkModal').modal('show');
		//this.bimageurl
		}
	}
	public selectBK(bk){
		this.bimageurl=bk;
		this.savedData.bk=bk;
		
	}*/
	public selectPage(type){
		let page:any;
		if(type=='portrait'){
			page=this.portraitSize;
		}else if(type=='landscape'){
			page=this.landscapeSize;
		}
		this.selectpage={'type':type, 'size':page};//console.log(this.selectpage)
	}
	/*private toStyle(data){//console.log(data);
		let html="";
		let p1=this.locations('<figure',data); //console.log(p1);
		let p2=this.locations('</figure>',data); //console.log(p2);
		for(let i=0; i<p1.length; i++){//console.log(i);
			if(i==0){
				html+=data.substring(0,p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				//console.log(subContent);
				html+=subContent; 
			}else{//console.log(p2[i-1]+9);//console.log(p1[i]);
				html+=data.substring((p2[i-1]+9),p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				//console.log(subContent);
				html+=subContent; 
			}
		}
		html+=data.substring((p2[p1.length-1]+9));
	
	 return html;
	}*/
	private convertFigure(node){//console.log(node);
		let value='';
		if($(node)[0].tagName=="FIGURE"){
			let item=$(node);//console.log(item)
			if(item.hasClass('image-style-align-left')){//console.log(item[0].style);
				item[0].style.float='left';								
			}else if(item.hasClass('image-style-align-right')){//console.log(item[0].style);
				item[0].style.float='right';				
			}else if(item.hasClass('image-style-align-center')){//console.log(item[0].style);
				item[0].style.display='block';
				item[0].style.margin='auto';
			}else{//console.log(item[0].style);
				item[0].style.display='block';
				item[0].style.margin='auto';
				if(!item[0].style.width){
					item[0].style.width='30%';
				}				
			}
			item.children('img')[0].style.width='100%';
			//console.log(item.children('figcaption'));
			if(item.children('figcaption')[0]){
				item.children('figcaption')[0].style.textAlign = "center"
			}
			//console.log(item[0].outerHTML);
			value=item[0].outerHTML;
		 }
		 return value; 
	}
	onSavedLogo(e){
		//this.tick = +(new Date());
		this.showLogo = e;
    
	}
	onEditReport(e){
		
	} 
	logOut(){
		this.logOutFlag++; //console.log(this.logOutFlag);
	}
	/*addTContent(){
		let item={'TYPE':'CONTENT_lISt','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Table of Content",'SUB_SECTIONS':[]};
		this.contents.splice(0,0,item);
		this.curIndex=[]
	}
	addApp(){
		let item={'TYPE':'APPENDIX','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Appendix",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	addHeader(){
		
	}*/
	addFPage(){
		let item={'TYPE':'FRONT','SECTION_TITLE': "Front Page", 'TEXT':'', 'pageSrc':'letter_style', 'header':null, 'footer':null,'SUB_SECTIONS':[]};
		item['id']=Utils.uniqueIdGenerator();
		this.frontpages.push(item);
	}
	addFSections(){
		let item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Section Title",'SUB_SECTIONS':[]};
		this.curIndex=[this.addon,this.addon,this.addon];
		this.addToContent(item, 'root');			
	}
	addPara(){
		let item={'TYPE':'PARA','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Text Section",'SUB_SECTIONS':[], 'OSNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addTable(){
		let item={'TYPE':'TABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Customized Table",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addMap(){
		let item={'TYPE':'MAP','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Map",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	addPhotos(){
		let item={'TYPE':'PHOTOS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Photo",'SUB_SECTIONS':[], 'photos':[]};
		this.addToContent(item);
	}
	addImage(){
		let item={'TYPE':'IMAGE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Image",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	/*addLContent(){
		let item={'TYPE':'LOCKED_CONTENT','DISPLAY_SEQUENCE': "N", 'SECTION_SEQUENCE': "",'SECTION_TITLE': "Locked Content",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}*/
	addToContent(item, type?){//console.log(this.selectedEditor)
		if(this.selectedEditor=='F'){
			item['id']=Utils.uniqueIdGenerator();
			item['OSNAME']=false;
			this.allEditor.push(item['id'])
			if(this.pageIndex[1]>-1){
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.splice(this.pageIndex[1]+1,0, item);
			}else{
				if(!this.frontpages[this.pageIndex[0]].SUB_SECTIONS){
					this.frontpages[this.pageIndex[0]]['SUB_SECTIONS']=[];
				}
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.push(item);
			}
			//console.log(this.frontpages[this.pageIndex[0]])
			
		}else if(this.selectedEditor=='O'){
		if(this.curIndex[0]>-1||type=='root'){
		item['id']=Utils.uniqueIdGenerator();
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			//this.curIndex=[index1,index2,index3+1];
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3+1,0, item);
		}else if(index2>-1&&!index3){
			//this.curIndex=[index1,index2+1,this.addon];
			//this.contents[index1].SUB_SECTIONS.splice(index2+1,0, item);
			
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,index2,0];
			}else{
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS=[item];
				//this.curIndex=[index1,index2+1,this.addon]
			}
			
		}else if(index1>-1&&!index2&&!index3){
			//this.curIndex=[index1+1,this.addon,this.addon];
			//this.contents.splice(index1+1,0,item);
			
			if(this.contents[index1].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,0,this.addon];
			}else{
				this.contents[index1].SUB_SECTIONS=[item];
				
			}
		}else{
			/*if((item.TYPE=='COSTTABLE')||(item.TYPE=='PCATABLE')){
				Swal.fire({
					icon:'warning',
					text: 'Please select a position for your table.',
				})					
				return
			}*/
			this.curIndex=[this.contents.length,this.addon,this.addon];			
			this.contents.push(item);
			
		}
		this.generateSeq();
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your section.',
			})					
			return
		}
		}
	}
	/*startNew(){
		this.resetTempForm();		
		let inputJson1={"PROCEDURE":"gettemplatetypecategory", "USER_ID":parseInt(this.userId)};
		//console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			//console.log(data);
			this.categories=data.RW_CATEGORY_LIST;			
		})
	}*/
	getTemplateTypeCategory(){
		let inputJson={"PROCEDURE":"gettemplatetypecategory", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			//console.log("templatetypecategory",data);
		//	this.templateFilterOptions.push(...data.RW_CATEGORY_LIST);
		this.templateFilterOptions2=data.RW_CATEGORY_LIST;
			//console.log("this.templateFilterOptions",this.templateFilterOptions)
		})

	}
	/*resetTempForm(){
		this.tempName=""
		this.selectedCover=""
		this.selectedHeader="";
		this.selectedFooter="";
		this.selectedIden="";
		this.tempContents=[];
		this.chosenSec=[];
		this.addedSec=[];		
	}
	onClose(){
		
	}*/
	selectSec(i){//console.log(i)
		let index=this.chosenSec.indexOf(i);
		if(index>-1){
			this.chosenSec.splice(index, 1);
		}else{
			this.chosenSec.push(i);
		}		
		
	}
	selectTemp(index){
		this.tempIndex=index;	//console.log(this.tempIndex);	
	}
	toggleChild(e){
		e.stopPropagation();
		let child=$(e.target).parents('a').next('div');////console.log(child);
		child.toggle();
		if(child.css('display')=='flex'){
			$(e.target).removeClass('fas fa-angle-down');
			$(e.target).addClass('fas fa-angle-right');
		}else{
			$(e.target).removeClass('fas fa-angle-right');
			$(e.target).addClass('fas fa-angle-down');
		}
	}
	/*addTo(type?){
		if(type=='all'){
			for(let i=0; i<this.sections.length; i++){				
				//this.tempContents.push(this.sections[i]);
				let item=JSON.parse(JSON.stringify(this.sections[i]));
				if(this.tempIndex>-1){					
					this.tempContents.splice(this.tempIndex+1+i, 0,item );
				}else{
					this.tempContents.push(item);
				}
				this.addedSec.push(this.sections[i].SECTION_TITLE);
			}
			
		}else if(type=='custom'){
			if(this.tempIndex>-1){
					this.tempContents.splice(this.tempIndex+1, 0, this.customSection);
				}else{
					this.tempContents.push(this.customSection);
				}				
		}else{
			
			for(let i of this.chosenSec){
				let item=JSON.parse(JSON.stringify(this.sections[i]));
				if(this.tempIndex>-1){
					this.tempContents.splice(this.tempIndex+1, 0, item);
				}else{
					this.tempContents.push(item);
				}
				this.addedSec.push(this.sections[i].SECTION_TITLE);
			}
						
		}
		
		this.chosenSec=[];
	}*/
	removeCount(item){
		let index=this.addedSec.indexOf(item);
		if(index>-1){
		 this.addedSec.splice(index,1);
		}
	}
	removeSec(type, data, index1?, index2?, index3?){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let datas:any
		if(type=='app'){
			that.appendices.SUB_SECTIONS.splice(index1,1);
			return
		}else if(type=='front'){
			if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS.splice(index2,1);
			}else{
				this.frontpages.splice(index1,1);
			}
			return
		}else if(type=='temp'){
			datas=that.tempContents
		}else if(type=='content'){
			datas=that.contents
		}
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3,1);
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS.splice(index2,1);
		}else{
			//that.removeCount(data.SECTION_TITLE)	
			datas.splice(index1,1);
		}
		that.generateSeq();
		}	
		})	
	}
	addChild(e,type, data, index1?, index2?){
		e.stopPropagation();
		let datas:any
		if(type=='app'){
			if(data.SECTION_TITLE){
				this.appendices.SUB_SECTIONS.push(data);
			}else{
				let item={'SECTION_TITLE': 'Appendix'};
				this.appendices.SUB_SECTIONS.push(item);
			}			
			return
		}else if(type=='temp'){
			datas=this.tempContents
		}else{
			datas=this.contents
		}
		if(index2>-1){
			this.curIndex=[index1,index2,datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length];////console.log(this.curIndex);
			let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE','DISPLAY_SEQUENCE':'Y'};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
			}
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.push(item);
			//this.curIndex=[datas.length-1,datas[index1].SUB_SECTIONS.length-1,datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length];//console.log(this.curIndex);
		}else{
			this.curIndex=[index1,datas[index1].SUB_SECTIONS.length,this.addon];////console.log(this.curIndex);
			let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE','SUB_SECTIONS':[],'DISPLAY_SEQUENCE':'Y'};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
			}
			datas[index1].SUB_SECTIONS.push(item);
			}
		let child=$(e.target).parent('a').next('div');////console.log(child);		
		if(child.css('display')=='none'){			
			$(e.target).prev().prev().removeClass('fas fa-angle-down');
			//$(e.target).prev().prev().addClass('fas fa-angle-right');
			child.css('display','block');
		}
		this.generateSeq();		
	}
	clearAdded(){
		for(let sec of this.sections){
				sec.added=false;
				this.tempContents=[];
		}
	}
	changeTitle(type, e, index1?, index2?, index3?){////console.log(e);
		this.selectedRow=-1;
		let datas:any;
		if(type=='front'){
			if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS[index2].SECTION_TITLE=e;
			}else if(index1>-1){
				this.frontpages[index1].SECTION_TITLE=e;
			}
			return
		}else if(type=='app'){
			if(index1>-1){
				this.appendices.SUB_SECTIONS[index1].SECTION_TITLE=e;
			}else{
				this.appendices.SECTION_TITLE=e;
			}
			return
		}else if(type=='temp'){
			datas=this.tempContents
		}else{
			datas=this.contents
		}
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].SECTION_TITLE=e;
		}else if(index2>-1){
			//let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE'};
			datas[index1].SUB_SECTIONS[index2].SECTION_TITLE=e;
		}else if(index1>-1){
			//let item={'SECTION_SEQUENCE': null,'SECTION_TITLE': 'TITLE','SUB_SECTIONS':[]};
			datas[index1].SECTION_TITLE=e;
		}
		this.curIndex=[index1, index2, index3];
	}
	
  drop(event: CdkDragDrop<string[]>) {//console.log('drag')
	moveItemInArray(this.contents, event.previousIndex, event.currentIndex);
  }
	dropCol(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.curTableData.cols, event.previousIndex, event.currentIndex);	
		for(let row of this.curTableData.rows){
			this.array_move(row,event.previousIndex, event.currentIndex )
		}	
		
	}
	dragStart(e){////console.log(e)
		$('#tableModal').draggable("disable");
	}
	dragEnd(e){////console.log(e)
		$('#tableModal').draggable("enable");
	}
	array_move(arr, old_index, new_index) {
	new_index =((new_index % arr.length) + arr.length) % arr.length;
	arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
	return arr; // for testing
	}

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
	this.generateSeq();
  }
  dropFItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
	dropApp(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.appendices.SUB_SECTIONS, event.previousIndex, event.currentIndex);
	}
	getConnectedList(): any[] {
		return this.contents.map(x => `${x.id}`);
	}
	getFConnectedList(): any[] {
		return this.frontpages.map(x => `${x.id}`);
	}
	dropFront(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.frontpages, event.previousIndex, event.currentIndex);
		
	}
	dropGroups(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.contents, event.previousIndex, event.currentIndex);
		this.generateSeq();
	}
	dropGroup(event: CdkDragDrop<string[]>, index) {
		moveItemInArray(this.contents[index].SUB_SECTIONS, event.previousIndex, event.currentIndex);
		this.generateSeq();
	}
	listid:string;
	getFListPosition(id, e,i?,j?){
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		this.listid=id;
		this.selectedEditor='F';
		this.curIndex=[];
		let status=$(e.target).hasClass('active'); //console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.pageIndex=[i,j];			
			this.scroll(id+'content');			
		}	
		this.addLib=false;
		
	}
	getListPosition(id, e,i?,j?,k?){
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		this.listid=id;
		this.selectedEditor='O';
		let status=$(e.target).hasClass('active'); //console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.curIndex=[i,j,k];//console.log(this.curIndex);
			this.pageIndex=[];
			let posi=id;
			/*if(k>-1){
				posi=(i+1)+'.'+(j+1)+'.'+(k+1);				
			}else if(j>-1){
				posi=(i+1)+'.'+(j+1);				
			}else if(i>-1){
				posi=(i+1).toString();
			}
			//console.log(posi);*/
			this.scroll(posi+'content');			
		}	
		this.addLib=false;
		
	}
	getFPosition(id, e,i?,j?){
		this.listid=id;
		this.selectedEditor='F';
		let posi=id;
			if(j>-1){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(i>-1){
				j=this.addon;				
			}
			this.scrollPanel(posi+'list');
			this.pageIndex=[i,j];//console.log(this.pageIndex);
			this.curIndex=[];
	}
	getPosition(id, e,i?,j?,k?){////console.log([i,j,k])
		//e.stopPropagation();
		if(this.cellShow){
			return
		}
		this.listid=id;
		this.selectedEditor='O';
		let status=$(e.target).hasClass('active');
		//this.curId=id; //console.log(id)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.curIndex=[i,j,k];////console.log(this.curIndex);
			this.pageIndex=[];
			let posi=id;
			if(k>-1){
				//posi=id; //(i+1)+'.'+(j+1)+'.'+(k+1);
				$('#expandIcon').removeClass('fa-angle-double-down');
				$('#expandIcon').addClass('fa-angle-double-up');
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}else if(j>-1){
				//posi=id; //(i+1)+'.'+(j+1);
				$('#expandIcon').removeClass('fa-angle-double-down');
				$('#expandIcon').addClass('fa-angle-double-up');
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(i>-1){
				//posi=id;//(i+1).toString();
			}
			////console.log(posi);
			//this.scroll(posi+'content');
			this.scrollPanel(posi+'list')
			this.addLib=true;
			if(this.curId!=id){
				this.selectedRow=-1;
				this.curId=id; ////console.log(id);
				let type=this.getContentData('TYPE'); ////console.log(type);
				if(type=='TABLE'){
					let data=this.getContentData('data');
					if(data&&(!data.erisName)){
						for(let row of data.rows){
							if(row.items&&row.items.length>0){
								row.selected=false;
							}
						}
						this.selectedRow=-1;
					}
				}
		}
		}

	}
	scroll(id) {
		////console.log(`scrolling to ${id}`);
		let el = document.getElementById(id);//console.log(el);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	scrollPanel(id) {
		////console.log(`scrolling to ${id}`);
		let el = document.getElementById(id);//console.log(el);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	selCate(e){
		let category=$(e.target).val();//console.log(category);
		let inputJson={"PROCEDURE":"gettemplatetypesubcategory", "USER_ID":parseInt(this.userId), "CATEGORY":category};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			this.temps=data.RW_SUBCATEGORY_LIST;			
		})
	}
	selTemp(e){
		let id=parseInt($(e.target).val()); //console.log(id);
		let inputJson={"PROCEDURE":"gettemplatetypecontents", "USER_ID":parseInt(this.userId), "TEMPLATE_TYPE_ID":id};
		//console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			if (JSON.parse(data).RESPONSE_STATUS=='N') {
				this.throwError(JSON.parse(data));
				return										
			}
			//console.log(JSON.parse(data));
			let info=JSON.parse(data).TEMPLATE_CONTENTS;
			////console.log(info);
			//this.types=data.RW_RPT_TYPES;
			if(info.length>0){
				this.sections=JSON.parse(info).TEMPLATE_SECTIONS;//console.log(this.sections)
			}else{
				this.sections=[];
			}
			//this.tempContents=[];
		})
		let inputJson1={"PROCEDURE":"gettemplatetypeappendix","USER_ID":parseInt(this.userId),"TEMPLATE_TYPE_ID":id};
		this.reportService.univeralService1(JSON.stringify(inputJson1)).subscribe(response => {
			//console.log(response);
			if (JSON.parse(response).RESPONSE_STATUS=='N') {
				this.throwError(JSON.parse(response));
				return										
			}
			let info=JSON.parse(response).TEMPLATE_APPENDIX;//console.log(info);
			this.appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
			if(info.length>0){
				this.tempAppendices=JSON.parse(info).TEMPLATE_APPENDIX[0];//console.log(this.appendices);
			}else{
				
				this.tempAppendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};;
			}
		})
	}
	addEditor(doc){
		/*let index:string
		if(k>-1){
			index=i+"-"+j+"-"+k;
		}else if(j>-1&&!k){
			index=i+"-"+j+"-";
		}else{
			index=i+"--";
		}*/
		if(this.allEditor.indexOf(doc.id)==-1){
			this.selectedCell=null;
			if(!doc.text||doc.text.length==0){
				this.toContentData('text','','');
			}
			this.allEditor.push(doc.id); //console.log(this.allEditor);		
			
		}
	}
	expandToggle(e){
		let level=$(e.target).prevAll('select').val();
		if(!$(e.target).hasClass('active')){
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}
			$(e.target).addClass('active');
			$(e.target).text('Collapse');
		}else{
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','none');
				})
			}
			$(e.target).removeClass('active');
			$(e.target).text('Expand');
		}
		
	}
	missingSlot;
	missingSlotMessage=''
	createSlot(e, ele?){//console.log(this.newSlotCat)
		if(!(this.newSlotType.length==0||this.newSlotLabel.trim()=== ''||this.newSlotCat.length==0||(this.newSlotType=='Selection'&&this.newSlotOps.length==0)||(this.newSlotType=='File'&&this.newSlotFile.url.length==0))){	let id=null;
			let slotContent='';
			let opContent='';
			let ext="";
			let name='';
			if(this.curTemp){
				id=this.curTemp.TEMPLATE_ID;
			}
			if(this.newSlotType=='Selection'){
				opContent=this.newSlotOps.join(';;');
				/*if(this.newSlotMultiple=='Y'){
					slotContent=opContent;
				}else{
					slotContent=this.newSlotOps[0];
				}*/
			}else if(this.newSlotType=='File'){
				if(this.newSlotFile.url.length>0){
					slotContent=this.newSlotFile.url;
					ext=this.newSlotFile.ext;
					name=this.newSlotFile.name;
				}				
			}else{
				slotContent=this.newSlotContent;
			}
			//console.log(slotContent);
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id, "KEY":this.newSlotLabel, "TYPE":this.newSlotType, "CONTENT":slotContent,"CATEGORY":this.newSlotCat};
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id.toString(),"SELECTION_CHOICES":opContent};
			let inputJson:any;
			if(this.newSlotType=='File'){
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id.toString(),"SELECTION_CHOICES":opContent, "FILE_EXTENSION":ext, 'FILE_NAME':name};
			}else{
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id.toString(),"SELECTION_CHOICES":opContent};
			}
			//console.log(inputJson);
			
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
				if (JSON.parse(data).RESPONSE_STATUS=='N') {
					this.throwError(JSON.parse(data));
					return										
				}
				let info=JSON.parse(data);
				//this.selectedSlot=JSON.parse(data);
			/*let item={'CATEGORY': info.CATEGORY,
					'CONTENT': info.CONTENT,
					'KEY': info.KEY,
					'SLOT_ID': info.SLOT_ID,
					'TYPE': info.TYPE,
					"TEMPLATE_ID":info.TEMPLATE_ID,
			}*/
			let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==info.CATEGORY);
			if(index>-1){
				this.groupSlots[index].RW_SLOTS.push(info);
				this.groupSlots[index].TOTAL_SLOTS+=1;
				this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
			}else{
				this.groupSlots.push({'CATEGORY':info.CATEGORY,'RW_SLOTS':[info],'TOTAL_SLOTS': 1,'TOTAL_TEMPLATE_SLOTS': 1});				
			}
			
			if(this.curTemp){
				this.curTemp.TOTAL_SLOTS+=1;
			}
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
			Toast.fire({
					icon: 'success',
					title: 'saved'
				})
				if(ele){
					ele.hide()
				}
			this.resetNewSlot();
		})
		}else{
			this.missingSlot=true
			this.missingSlotMessage = "* "
			if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
				this.missingSlotMessage = this.missingSlotMessage + "Identifier"
			}
			if(this.newSlotCat.length==0){
				if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Category"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Category"
				}
			}
			if(this.newSlotType==''){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Type"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Type"

				}
			}
			if(this.newSlotType=='Selection'&&this.newSlotOps.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Selection"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Selection"

				}
			}
			if(this.newSlotType=='File'&&this.newSlotFile.url.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", File"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "File"

				}
			}
			this.missingSlotMessage = this.missingSlotMessage + " not valid"
		}
	}
	selectSlot(slot){
		//console.log(slot);
		this.selectedSlot=slot;
	}
	addSlotPosi(i?,j?,k?){
		this.selectedSlot=[];
		if(k>-1){
			this.curIndex=[i,j,k];			
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];			
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];			
		}
		
	}
	addSlot(){//console.log(this.selectedSlot)
		this.toContentData('slots', this.selectedSlot, 'addSlotModal');
		//$('#addSlotModal').modal('hide');
		this.selectedSlot=[];		
	}
	addSlotPrep(type?){
		this.slotToLib=true;
		this.filteredData=null;
		this.selectedSlot=[];
		this.curLib=[];
		this.curLibId=[];
		if(type&&type=='new'){
			this.newLib=true;
			this.addLib=false;
		}else{
			this.newLib=false;
		}
	}
	addSlotToLib(){//console.log(this.selectedSlot)
		let content='';
		for(let item of this.selectedSlot){
			//let itemHtml='<span class="reportTag" data-id="'+item.SLOT_ID+'" data-name="'+item.KEY+'" data-original-title="This Report Tag has no value" data-value="undefined" style="background-color:#C2D63F;">'+'{{'+item.KEY+'}}'+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text'};
			content=JSON.stringify(obj);
			
		
		this.itemIndex+=this.itemIndex;
		this.addedItem={'index':this.itemIndex,'content':content};
		}
		//this.addedItem=content; //this.selectedSlot;
		$('#addSlotModal').modal('hide');
	}
	showSlot(libs){
		let newLibs=[];
		this.selectedRow=-1;
		if(libs[0].LIBRARY_ID>-1){
			let libarray=[];
			for(let lib of libs){
				libarray.push(lib.LIBRARY_ID);
			}
			let libstring=libarray.join(',');
			let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			let updatedLibs=data.RW_LIBRARY;
			this.toContentData('choice', updatedLibs, '')
			//return updatedLibs;
		})
			//this.toContentData('choice', newLibs, '')
		}
	}
	deleteSlot(id, item){//console.log(item)
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			let inputJson={"PROCEDURE":"deleteslot","USER_ID":parseInt(this.userId),"SLOT_ID":parseInt(id)};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
				let info=JSON.parse(data);
				let msg=info.MESSAGE;
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(info.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==item.CATEGORY);
					if(index>-1){
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index1>-1){
							this.groupSlots[index].RW_SLOTS.splice(index1,1);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index2>-1){
							this.groupSlots[index].RW_TEMPLATE_SLOTS.splice(index2,1);
						}
					}				
					Toast.fire({
						icon: 'success',
						title: msg
					})
				}else{
					this.throwError(info);	
				}
			})	
		}	
		})	
	}
	expandAll() {
    if(!this.isExpanded){
      this.groupSlots.forEach(data =>{
        this.expandedRows[data.CATEGORY] = true;
      })
	  this.isExpanded=true
	  //console.log(this.expandedRows);
    } else {
      this.expandedRows={};
	  this.isExpanded = false;
    }
    //this.isExpanded = !this.isExpanded;
  }
  slotChkToggle(data){//console.log(data);
		if(data.RW_SLOTS.length>0){
			let allSlot=data.RW_SLOTS;
			for(let item of allSlot){
				this.addToTemp(item,data.CATEGORY);
			}
		}else{
			let allSlot=data.RW_TEMPLATE_SLOTS;
			for(let item of allSlot){
				this.removeFromTemp(item,data.CATEGORY);
			}
		}
		this.slotCheckAll=!this.slotCheckAll; 
  }
  nameValidate(event){
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  }
	addSlotToTemp(e,r,cat){//console.log(r)
		if(e.target.checked){
			this.addToTemp(r,cat);
		}else{
			this.removeFromTemp(r,cat);
			
		}
	}
	addToTemp(r,cat){
		let inputJson={"PROCEDURE":"addslottotemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.curTemp.TEMPLATE_ID,'SLOT_ID':r.SLOT_ID};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {////console.log(response)
				let data=JSON.parse(response);
				if(data.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==data.CATEGORY);
					if(index>-1){
						this.curTemp.TOTAL_TEMPLATE_SLOTS+=1;
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==data.SLOT_ID);
						this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
						if(index1>-1){
							this.groupSlots[index].RW_SLOTS.splice(index1,1);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==data.SLOT_ID);
						if(index2==-1){
							r.TEMPLATE_IND='Y';
							/*let item={'CATEGORY': data.CATEGORY,
								'CONTENT': data.CONTENT,
								'KEY': data.KEY,
								'SLOT_ID': data.SLOT_ID,
								'SYSTEM_IND': data.SYSTEM_IND,
								'TEMPLATE_IND': data.TEMPLATE_IND,
								'TYPE': data.TYPE,
							}*/
							this.groupSlots[index].RW_TEMPLATE_SLOTS.push(r);
						}
					}				
					/*Toast.fire({
						icon: 'success',
						title: msg
					})*/
				}else{
					this.throwError(data);	
				}
				
			/*{"PROCEDURE":"addslottotemplate","USER_ID":213223,"TEMPLATE_ID":3,"SLOT_ID":8,"STATUS":"Y","MESSAGE":"Slot added to Template was successful"}*/
			})
	}
	removeFromTemp(r,cat){
		let inputJson={"PROCEDURE":"removeslotfromtemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":this.curTemp.TEMPLATE_ID,'SLOT_ID':r.SLOT_ID};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {//console.log(response)
				let data=JSON.parse(response);
				if(data.RESPONSE_STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==cat);
					this.curTemp.TOTAL_TEMPLATE_SLOTS-=1;
					this.groupSlots[index].TOTAL_TEMPLATE_SLOTS-=1;
					if(index>-1){
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==r.SLOT_ID);
						if(index1==-1){
							r.TEMPLATE_IND='N';
							this.groupSlots[index].RW_SLOTS.push(r);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==r.SLOT_ID);
						if(index2>-1){
							this.groupSlots[index].RW_TEMPLATE_SLOTS.splice(index2,1);
						}
					}				
					/*Toast.fire({
						icon: 'success',
						title: msg
					})*/
				}else{
					this.throwError(data);	
				}
			})
	}
	selLib(item){//console.log(item)
		let index=this.curLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
		if(index>-1){
			this.curLib.splice(index,1);
			this.curLibId.splice(index,1);
		}else{
			this.curLib.push(item);
			this.curLibId.push(item.LIBRARY_ID);
		}
				
	}
	
	addSelLib(){//console.log(this.addedLib);
		if(this.curLib.length>0){
			for(let item of this.curLib){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(item);
				}
			}
			this.curLib=[];
			this.curLibId=[];	
		}
		
	}
	addAllSelLib(){//console.log(this.addedLib);
	//console.log(this.filteredData)
		if(this.libLabels.length<11&&!this.filteredData){
			for(let flib of this.libLabels){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(flib);
				}
			}
		}else if(this.filteredData&&this.filteredData.length<11){
			//this.addedLib = [...this.addedLib, ...this.filteredData]; //console.log(this.addedLib);
			for(let flib of this.filteredData){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(flib);
				}
			}
		}
		this.curLib=[];
		this.curLibId=[];	
	}
	rmvAddedLib(){
		for(let item of this.curLib){
			let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.addedLib.splice(index,1);
			}
		}
		this.curLib=[];
		this.curLibId=[];
	}
	clearAddedLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
	}
	cancleLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
		$('#libraryModal').modal('hide');
	}
	deleteLib(data){//console.log(data)
		let inputJson={"PROCEDURE":"deletelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":data.LIBRARY_ID}
		/*let inputJson={"PROCEDURE":"updatelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":data.LIBRARY_ID,'ITEM_TITLE':data.ITEM_TITLE};
		//console.log(inputJson);*/
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			//console.log(response);//{"STATUS":"Y","MESSAGE":"Deletion of Library Entry was successful"}
			let info=JSON.parse(response);
			let msg=info.MESSAGE;
			if(info.RESPONSE_STATUS=="Y"){
				let index=this.libraries.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
				if(index>-1){
					this.libraries.splice(index,1);
				}
				if(this.filteredData){
					let index1=this.filteredData.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
					if(index1>-1){
						this.filteredData.splice(index1,1);
					}	
				}				
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: msg
				})
				
          }else{
            this.throwError(info);	
          }
		})
			
	}
	selSlot(item){//console.log(item)
		let index=this.curSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
		if(index>-1){
			this.curSlot.splice(index,1);
			this.curSlotId.splice(index,1);
		}else{
			this.curSlot.push(item);
			this.curSlotId.push(item.SLOT_ID);
		}	
		//console.log(this.curSlotId)
	}
	addSelSlot(){
		if(this.curSlot.length>0){
			for(let item of this.curSlot){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(item);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
		
	}
	addAllSelSlot(){
		if(this.slots.length<11&&!this.filteredData){
			for(let fslot of this.slots){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
			
		}else if(this.filteredData&&this.filteredData.length<11){
			for(let fslot of this.filteredData){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	rmvAddedSlot(){
		for(let item of this.curSlot){
			let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
			if(index>-1){
				this.selectedSlot.splice(index,1);
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	clearAddedSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
	}
	cancleSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
		$('#addSlotModal').modal('hide');
	}

	changeCat(cat){
		//console.log(cat)
	}
	resetNewSlot(){
		this.missingSlot=false;
		this.missingSlotMessage='';
		this.newSlotLabel="";
		this.newSlotCat="";
		this.newSlotType="";
		this.newSlotContent="";
		this.newSlotMultiple='N';
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
		this.tableContent=[];
		this.newSlotOps=[];
		this.resetLib();
	}
	addLibToSlot(){
		if(this.newSlotType=='Selection'){
			this.newSlotOps=[];
			for(let lib of this.addedLib){
				this.newSlotOps.push(lib.CONTENT);
			}
			$('.slotBtn')[0].classList.add("disabled"); 
		}else{
			this.newSlotContent="";
			for(let lib of this.addedLib){
				this.newSlotContent+=lib.CONTENT;
			}
		}
		$('#libraryModal').modal('hide');
		this.resetLib();
	}
	resetLib(){
		this.addedLib=[];
		this.filteredData=null;
	}
	secSetting(e){
		//e.stopPropagation();
	}
	addLibToDoc(){
		/*let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]['libs']=this.addedLib;
		}else if(index2>-1){
			this.contents[index1].SUB_SECTIONS[index2]['libs']=this.addedLib;;
		}else if(index1>-1){
			this.contents[index1]['libs']=this.addedLib;
		}*/
		this.toContentData('libs', this.addedLib, 'libraryModal');
		//$('#libraryModal').modal('hide');
		this.resetLib();	
	}
	showLib(libs){
		//this.addedLib=libs;
		//$('#showLibModal').modal('show');
	}
	
	generateSeq(){
		if(this.contents.length>0){
			let i=0;
			for (let item1 of this.contents){
				if(item1.DISPLAY_SEQUENCE=='Y'){
					i++;
					item1.SECTION_SEQUENCE=i+'.';
								
					if(item1.SUB_SECTIONS&&item1.SUB_SECTIONS.length>0){
						let j=0;
						for (let item2 of item1.SUB_SECTIONS){
							if(item2.DISPLAY_SEQUENCE=='Y'){
								j++;
								item2.SECTION_SEQUENCE=i+'.'+j;	
													
								if(item2.SUB_SECTIONS&&item2.SUB_SECTIONS.length>0){
									let k=0;
									for (let item3 of item2.SUB_SECTIONS){
										if(item3.DISPLAY_SEQUENCE=='Y'){
											k++;
											item3.SECTION_SEQUENCE=i+'.'+j+'.'+k;
																				
											if(item3.SUB_SECTIONS&&item3.SUB_SECTIONS.length>0){
												let l=0;
												for (let item4 of item3.SUB_SECTIONS){
													if(item4.DISPLAY_SEQUENCE=='Y'){
														l++;
														item4.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l;														
													
														if(item4.SUB_SECTIONS&&item4.SUB_SECTIONS.length>0){
															let m=0;
															for (let item5 of item4.SUB_SECTIONS){
																if(item5.DISPLAY_SEQUENCE=='Y'){
																	m++;
																	item5.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l+'.'+m;
																}else{
																	item5.SECTION_SEQUENCE='';
																}
															}
														}
													
													}else{
														item4.SECTION_SEQUENCE='';
													}
												}
											}
										
										}else{
											item3.SECTION_SEQUENCE='';
										}
									}
								}
							
							}else{
								item2.SECTION_SEQUENCE='';
							}
						}
					}
				
				}else{
					item1.SECTION_SEQUENCE='';
				}	
			}
		}
	}
	onFilter(event, dt) { 
		this.filteredData = event.filteredValue; //console.log(this.filteredData);
	}
	resetNewLibrary(){
		this.addLibWarn=false;
		$('#libTitle').val('');
		$('#libLabel').val('');		
		this.inputLabels='';
		this.newLibPara[0]='';
		this.newLibPara[2]='';
		this.newLibPara[3]='';
		this.newLibPara[1]='';
		this.newLibPara[4]='';
		this.newLibPara[5]='';
	}
	createLibrary(e, type?){
		this.addLibWarn=false;
		let ele=$(e.target).siblings('input');
		const title=ele[0].value;
		if(title.length==0){
			this.addLibWarn=true;
			return
			
		}
		const label=this.inputLabels;
		const instr=this.newLibPara[0];
		const content=this.newLibPara[2];
		const eleContent=this.newLibPara[3];
		const eleInstruction=this.newLibPara[1];
		let inputJson={"PROCEDURE":"insertlibraryentry", "USER_ID":parseInt(this.userId), "ITEM_TITLE":title, "CONTENT":content, "INSTRUCTIONS":instr, "LABELS":label, 'CONTENT_HTML':eleContent, 'INSTRUCTIONS_HTML':eleInstruction };
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			if (data.LIBRARY_ID){
				this.libraries.splice(0,0, data);
			}
			if(type=='new'){
				this.addLibShow=false
			}else{
				this.resetNewLibrary()
			}
		})
	}
	toCreateTable(i?, j?, k?, l?, m?){//console.log(i,j,k)
		this.curTableData=null;	
		this.colNo=0;
		this.rowNo=0;
		if(this.selectedEditor=='F'){
			this.curTableData=this.getFContentData('data');
		}else if(this.selectedEditor=='O'){
			//this.curTableData=this.getContentData('data');
		
		if(k>-1){
			this.curIndex=[i,j,k];
			if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data;	//console.log(this.curTableData)
				
			}			
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];
			if(this.contents[i].SUB_SECTIONS[j].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].data;//console.log(this.curTableData)
			};			
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];
			if(this.contents[i].data){
				this.curTableData=this.contents[i].data;
			};			
		}
		}
		if(!this.curTableData){
			this.curTableData={'cols':[],'rows':[]};
			if(this.selectedEditor=='F'){
				this.slotTableType=0;
			}else if(this.selectedEditor=='O'){
				this.slotTableType=1;
			}		
		}else{
			this.slotTableType=this.curTableData.src;
			this.colNo=this.curTableData.cols.length;
			this.rowNo=this.curTableData.rows.length;			
		}	
	}
	createTable(e){//console.log(this.rowNo);
		//console.log(this.curTableData.cols);
		if((!this.curTableData.erisName&&this.rowNo<1)||this.curTableData.cols.length==0){
			Swal.fire({
				icon: 'info',
				title: "Columns and Rows must more than 0."
			})
			return
		}
		if(this.curTableData.rows.length==0){
			if(this.slotTableType==1){
				this.curTableData.src=this.slotTableType;
				this.rowNo=1;
				let firstCol={'INTERNALNAME': "ES_RID",'NAME': "ID",'TYPE': "text",'unit': "%",'width': 0, 'hide':true};
				this.curTableData.cols.unshift(firstCol);
				//console.log(this.curTableData);
			}else if(this.slotTableType==2){
				this.curTableData.src=this.slotTableType;
				//console.log(this.curTableData);
			}else{
				this.curTableData.SLOT_ID=null;
				this.curTableData.src=this.slotTableType;
				//this.rowNo=10;
				 
			}
			//console.log(this.rowNo)
			if(this.slotTableType==0){			
		for(let i=0; i<this.rowNo; i++){
			let row=[];
			let rowData={'items':[]};
			for(let j=0; j<this.curTableData.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':''};
				
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				rowData[this.curTableData.cols[j].INTERNALNAME]='';
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				////console.log(item)
				row.push(item);
			}
			rowData.items=row;
			this.curTableData.rows.push(rowData);
			
		}
		}else{
		for(let i=0; i<this.rowNo; i++){
			let row=[]
			for(let j=0; j<this.curTableData.cols.length; j++){//console.log(this.curTableData.cols[j]);
				let item={'COLUMNINTERNALNAME':'','data':''};
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				//if(this.curTableData.cols[j].TYPE=="dropdown"){
				//	item['choice']=[];
				//}
				////console.log(item)
				row.push(item);
			}
			this.curTableData.rows.push(row);
			
		}
		}
		}
		if(this.curTableData.slotName&&this.curTableData.slotName.length>-1){
			if(this.selectedEditor=='F'){
				this.changeTitle('front',this.curTableData.slotName,this.pageIndex[0],this.pageIndex[1]);
			}else if(this.selectedEditor=='O'){
				if(this.curIndex[2]>-1){
					this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
				}else{
					this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1]);
				}
			}
	
		}
		if(this.curTableData.erisName&&this.curTableData.erisName.length>-1){
			if(this.selectedEditor=='F'){
				this.changeTitle('front',this.curTableData.erisName,this.pageIndex[0],this.pageIndex[1]);
			}else if(this.selectedEditor=='O'){
				if(this.curIndex[2]>-1){
					this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
				}else{
					this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1]);
				}
			}
		}
		//this.curTableData.cols=item;
		//this.curTableData.rows=[item1,item2, item3, item4];
		$("#tableModal").modal('hide');
		if(this.selectedEditor=='F'){
			this.toFContentData('data', this.curTableData, 'tableModal')
		}else if(this.selectedEditor=='O'){
			this.toContentData('data', this.curTableData, 'tableModal')
		}	
	}
	addOption(e, index){
		let val=$(e.target).val();
		this.curTableData.cols[index].push(val);
	}
	addCol(){
		let id='col'+this.curTableData.cols.length.toString();
		 //let item={'INTERNALNAME':id, 'name':'','type':'text'};
		let item={'INTERNALNAME':id,'NAME':'Header'+this.curTableData.cols.length.toString(),'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
		item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
		item['text']=item.NAME;
		this.curTableData.cols.push(item);//console.log(this.curTableData.cols)
		if(this.curTableData.rows.length>0){
			for(let row of this.curTableData.rows){//console.log(row)
				if(row.items){
					row[id]='';
					if(row.items.length==1&&row.items[0].colspan){
						row.items[0].colspan++;
					}else{
						row.items.push({'COLUMNINTERNALNAME':id, 'DATA':''});
					}
				}else{
					row.push({'COLUMNINTERNALNAME':id, 'DATA':''});	
				}								
			}			
		}
		this.colNo++;
		if(this.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
			let width=Math.floor((96/this.curTableData.cols.length)*100)/100;//console.log(width);
			for(let i=0; i<this.curTableData.cols.length; i++){
				this.curTableData.cols[i].width=width;
				this.curTableData.cols[i].unit='%';
			}
		}
	}
	deleteCol(index){
		let that=this;
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let id=that.curTableData.cols[index].INTERNALNAME; //console.log(id)
		if(that.curTableData.cols.length>1){
		that.curTableData.cols.splice(index, 1);
		if(that.curTableData.rows.length>0){
			let index1=-1;
			if(that.curTableData.rows[0].items){
				
			}else{
				index1=that.curTableData.rows[0].findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index1)
			}
			for(let row of that.curTableData.rows){
				if(row.items&&row.items.length>0){
							row[id]=null;
							let index2=row.items.findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index2)
							if(index2>-1){//console.log(row)
								if(row.items.length==1&&row.items[0].colspan){//console.log(row)
									row.items[0].COLUMNINTERNALNAME=that.curTableData.cols[0].INTERNALNAME;
									row.items[0].colspan--;
								}else{//console.log(row)
									row.items.splice(index2, 1);
								}
							}else{
								if(row.items.length==1&&row.items[0].colspan){
									row.items[0].colspan--;
								}
							}
					
						}else{
							if(index1>-1){
								row.splice(index1, 1);
							}
						}
			}
		}
		
		if(that.isEven){
			let total=that.curTableData.cols.length;
			let i=0;
			if(that.curTableData.SLOT_ID>-1){
				total-=1;
				i=1
			}
			if(this.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
			let width=Math.floor((96/this.curTableData.cols.length)*100)/100;//console.log(width);
			for(let i=0; i<this.curTableData.cols.length; i++){
				this.curTableData.cols[i].width=width;
				this.curTableData.cols[i].unit='%';
			}
			}
		}
		}else{
				//console.log(that.curTableData.cols);
				alert('Column can no be deleted since only 1 column left!');
				
			}
		}
			})
	}
	changeLabel(e, index1?){
		this.selectedRow=-1;
		//this.selectedCell={'row':index1,'col':index2};
		if(index1>-1){
			this.curTableData.cols[index1].NAME=e;
			this.curTableData.cols[index1].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);

		}else{
			this.toContentData('data', e, "")
		}
		/*if(index2){
			this.curTableData.rows[index2][index1].name=e;////console.log(this.curTableData.rows[index2][index1].name);
		}else{
			this.curTableData.cols[index1].name=e;////console.log(this.curTableData.cols[index1].name);
		}*/
	}
	selCell(i,j?){//console.log(i, j);
		if(j!=null){
			this.selectedCell={'row':i,'col':j};
		}else{
			this.selectedCell={'row':-1,'col':i};
		}
	}
	getRow(h){
		if(this.selectedRow==h){
			this.selectedRow=-1;
		}else{
			this.selectedRow=h;
		}
	}
	toContentData(field, data, pop, preIndex?){//console.log(this.curIndex);
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(preIndex){//console.log(preIndex);
			index1=preIndex[0];
			index2=preIndex[1];
			index3=preIndex[2];
		}
		if(!this.selectedCell){			
			if(index3>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
						}						
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);
						}
						//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);	
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);	
					}					
				}else{
					this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][field]=data;
				}
			}else if(index2>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
						}						
					}else{
						this.contents[index1].SUB_SECTIONS[index2].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].libs.push(data);	
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].libs.push(data);	
					}					
				}else{

					this.contents[index1].SUB_SECTIONS[index2][field]=data;//console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.contents[index1].slots){
						let index=this.contents[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){						
							this.contents[index1].slots.push(data);	
						}
					}else{
						this.contents[index1].slots=[];
						this.contents[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].libs){
						let index=this.contents[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].libs.push(data);	
						}
					}else{
						this.contents[index1].libs=[];
						this.contents[index1].libs.push(data);	
					}					
				}else{
					this.contents[index1][field]=data;
				}
				////console.log(this.contents[index1].libs)
			}
		}else{//console.log(this.selectedCell)
			if(index3>-1){
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items){
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
					}
				}else{
					if(this.selectedCell.row>-1){
							//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
						if(field=='htmltext'){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
						}else if(field.length>0){//console.log(field)
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][field]=data;
						}else{
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data;
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.cols[this.selectedCell.col].NAME=data
					}
					//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].name=data
				}
			}else if(index2>-1){//console.log(this.contents[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items){
					this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data; //console.log(data)
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data; //console.log(data)
					}
				}else{//console.log(this.selectedCell.row);
					if(this.selectedCell.row>-1){
						//this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
						if(field=='htmltext'){
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
						}else if(field.length>0){//console.log(field)
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][field]=data;
						}else{
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		//console.log(this.contents);
	}
	toFContentData(field, data, pop, preIndex?){//console.log(this.pageIndex);
		let index1=this.pageIndex[0];
		let index2=this.pageIndex[1];
		if(!this.selectedCell){			
			if(index2>-1){
				if(field=='slot'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].slots){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
						}						
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].slots=[];
						this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].libs){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);	
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].libs=[];
						this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);	
					}					
				}else{
				this.frontpages[index1].SUB_SECTIONS[index2][field]=data;//console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.frontpages[index1].slots){
						let index=this.frontpages[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){						
							this.frontpages[index1].slots.push(data);	
						}
					}else{
						this.frontpages[index1].slots=[];
						this.frontpages[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].libs){
						let index=this.frontpages[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].libs.push(data);	
						}
					}else{
						this.frontpages[index1].libs=[];
						this.frontpages[index1].libs.push(data);	
					}					
				}else{
				this.frontpages[index1][field]=data;
				}
			}
		}else{//console.log(this.selectedCell)
			if(index2>-1){//console.log(this.frontpages[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data; //console.log(data)
				}else{//console.log(this.selectedCell.row);
					if(this.selectedCell.row!=null){//console.log(this.frontpages[index1].SUB_SECTIONS[index2].data.rows)
						if(field=='htmltext'){
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
						}else if(field.length>0){//console.log(field)
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
						}else{
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		//console.log(this.frontpages);
	}
	getFContentData(source){//console.log(this.pageIndex);
		let index1=this.pageIndex[0];////console.log(index1);
		let index2=this.pageIndex[1];////console.log(index2);
		let dest:any;
		if(index2>-1){
			if(this.frontpages[index1].SUB_SECTIONS[index2][source]){
				dest=this.frontpages[index1].SUB_SECTIONS[index2][source];
			};			
		}else if(index1>-1){////console.log(index1);
			if(this.frontpages[index1][source]){
				dest=this.frontpages[index1][source];
			};			
		}
		return dest;
	}
	getContentData(source){//console.log(this.curIndex);
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		let dest:any;
		
		if(index3>-1){
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source];
			}			
		}else if(index2>-1){
			if(this.contents[index1].SUB_SECTIONS[index2][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2][source];
			};			
		}else if(index1>-1){//console.log(index1);
			if(this.contents[index1][source]){
				dest=this.contents[index1][source];
			};			
		}
		return dest;
	}
	startNewLib(){
		this.inputLabels="";
	}
	addLabel(e){
		let text=$(e.target).prev().prev('input').val(); //console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				this.inputLabels+=ar.trim()+';';
			}
		}
		$(e.target).prev().prev('input').val('');
	}
	removeLabel(index){//console.log(index);
		let labels=this.inputLabels.split(';');
		labels.splice(index, 1);
		this.inputLabels=labels.join(';');
		//console.log(this.inputLabels);
	}
	moveUp(index){
		let data=this.getContentData('data'); //console.log(data)
		if(index>0){
			this.array_move(data.rows,index, index-1 );
			this.selectedRow-=1;
		}
	}
	moveDown(index){
		let data=this.getContentData('data');
		if(index<(data.rows.length-1)){
			this.array_move(data.rows,index, index+1 );	
			this.selectedRow+=1;
		}	
	}
	deleteRow(index){
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let data=this.getContentData('data');
		data.rows.splice(index,1);
		}
			})
	}
	addSub(e){
		let posi=$(e.target).prev('select').val();//console.log(posi)
		let data=this.getContentData('data'); //console.log(data);
		let row=[{'COLUMNINTERNALNAME':'','data':'', 'celAllign':posi}];
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
		}	
	}
	addRows(e){
		let no=$(e.target).prev('input').val();
		if(no>0){
			let data=this.getContentData('data');
			for(let i=0; i<no; i++){
				let row=[]
				for(let j=0; j<data.cols.length; j++){
					let item={'COLUMNINTERNALNAME':'','data':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					if(data.cols[j].type=="dropdown"){
						item['choice']=[];
					}
					//console.log(item)
					row.push(item);
				}
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
				}else{
					data.rows.push(row);
				}
				
			}
		}
	}
	toNewLib(){
		this.newLibPara=[];
		this.inputLabels='';
		this.addLibShow=true;
		
	}
	libPara(e, index){
		////console.log(e)
		this.newLibPara[index]=e;////console.log(this.newLibPara);
		if(index==1){
			this.newLibPara[4]=e;
		}else if(index==3){
			this.newLibPara[5]=e;
		}
	}

	getTable(data){//console.log(data.TYPE)
		if(data.TYPE=='Table'){
			this.tableContent=JSON.parse(data).HEADERS;
		}else if(data.TYPE=='Selection'){
			let ops=data.SELECTION_CHOICES;
			this.tableContent=ops.split(';;'); 
		}
		//console.log(this.tableContent);
	}	
	addOpItem(e){
		if(this.newSlotOp.length>0){
			this.newSlotOps.push(this.newSlotOp)
			this.newSlotOp='';
			//$('.slotBtn')[1].classList.add("disabled"); 
		}
	}
	
	clearOpItem(){
		this.newSlotOps=[];
		$('.slotBtn').each(function(){
			if($(this).hasClass('disabled')){
				$(this).removeClass('disabled');
			}
		})
	}
	setTableSrc(type){
		this.slotTableType=type;
		this.curTableData={'cols':[],'rows':[]};
		if(type==0){			
			for(let i=0; i<this.colNo; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':5, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
				item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				item['text']=item.NAME;
				this.curTableData.cols.push(item)
			}
			this.curTableData.slotName=null;
			this.curTableData.erisName=null;			
		}else if(type==2){			
			this.curTableData.SLOT_ID=null;	
			this.curTableData.slotName='';			
		}else{
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
		}
		
	}
	getTables(type){
		let inputJson:any;
		this.erisSlots=[];
		this.tableSlots=[];
		if(type=='eris'){
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"Y"};
		}else{
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"N"};
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			if(type=='eris'){
				this.erisSlots=data.RW_SLOTS;
			}else{
				this.tableSlots=data.RW_SLOTS;
			}
		})
	}
	getSlotTable(e){
		let index=$(e.target).val();//console.log(index);
			if(index>-1){
				this.curTableData.cols=JSON.parse(this.tableSlots[parseInt(index)].CONTENT).HEADERS; //console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=this.tableSlots[parseInt(index)].SLOT_ID;
				this.curTableData.slotName=this.tableSlots[parseInt(index)].KEY;
				this.curTableData.rows=[];
				this.colNo=this.curTableData.cols.length;
				if(this.isEven){
					let width=Math.floor(100/this.colNo);
					for(let i=0; i<this.colNo; i++){
						this.curTableData.cols[i].width=width;
						this.curTableData.cols[i].unit='%';
					}
				}
			}else{
				this.curTableData={'cols':[],'rows':[]}; //console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=null;
				this.curTableData.slotName='';
				this.colNo=0;
				this.curTableData.rows=[];
			}
		
	
	}
	getErisTable(e){//console.log(this.erisSlots);
		let index=$(e.target).val();//console.log(index);
		if(index>-1){
			this.curTableData.cols=JSON.parse(this.erisSlots[parseInt(index)].CONTENT).HEADERS; //console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=this.erisSlots[parseInt(index)].SLOT_ID;
			this.curTableData.erisName=this.erisSlots[parseInt(index)].KEY;
			this.colNo=this.curTableData.cols.length;
			if(this.isEven){
				let width=Math.floor(100/this.colNo);
				for(let i=0; i<this.colNo; i++){
					this.curTableData.cols[i].width=width;
					this.curTableData.cols[i].unit='%';
				}
			}
		}else{
			this.curTableData={'cols':[],'rows':[]}; //console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
			this.colNo=0;
		}
	}
	addRepeat(type, item, cat?){//console.log(type, item);
		let content='';
		
		if(type=='choice'){
			//console.log(type, item);
			let content=item.CONTENT.split(';');
			this.toContentData('choice', content, '');	
			return
		}
		if(type=='slot'){
			let obj:any;
			if(item=='signature'){
				obj={'name':'signature', 'dataId':'signature'+this.itemIndex, 'dataType':'text', 'status':'N'};
			}else if(item=='seal'){
				obj={'name':'seal', 'dataId':'seal'+this.itemIndex, 'dataType':'text', 'status':'N'};
			}else{
				obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			
			}
			//let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.itemIndex++;	//console.log(this.itemIndex);
			let data={'index':this.itemIndex,'content':content, 'type':type};			
			if(cat){
				this.addToTemp(item,cat);
			}
			if(this.selectedEditor=='P'){//console.log(this.selectIndex);
					this.pdfFname['addedItem']=data;	
					this.pdfFname['reqIndex']=this.itemIndex;
			}else if(this.cellShow){
					this.curSec['addedItem']=data;
					this.curSec['reqIndex']=this.itemIndex;
					//this.toContentData(type, info, '');	
			}else if(this.selectedEditor=='F'){//console.log(this.selectIndex);
					//this.frontpages[this.selectIndex]['addedItem']=data;
					this.toFContentData('addedItem', data, '');
					this.toFContentData(type, item, '');	
					this.toFContentData('reqIndex', this.itemIndex, '');					
				}else{
					this.toContentData('addedItem', data, '');
					this.toContentData('reqIndex', this.itemIndex, '');
				}
			
		}else if(type=='lib'){
			if(this.cellShow){
				if(this.curCell){
					if(this.curCell['libs']){
						this.curCell['libs'].push(item);
					}else{
						this.curCell['libs']=[];
						this.curCell['libs'].push(item);
					}
					
				}
				//this.toContentData(type, data, '');	
			}else if(this.selectedEditor=='F'){//console.log(this.selectIndex);
				this.toFContentData(type, item, '');					
			}else{
				this.toContentData(type, item, '');	
			} 
				let index=this.addedLibs.indexOf(item.LIBRARY_ID);
				if(index==-1){
					this.addedLibs.push(item.LIBRARY_ID);
				}
							
		}else if(type=='newLib'){
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.addedItem={'index':this.itemIndex,'content':content, 'type':'slot'};//console.log(this.addedItem);
			//this.toContentData('addedItem', data, '');
			if(cat){
				this.addToTemp(item,cat);
			}
			this.itemIndex++;
			this.toContentData(type, item, '');	
		}		
	}
	showSlots(){
		$('.nav-tabs a[href="#slot"]').tab('show');
		this.slotGroup='A';
		this.clearAddedSlot();
		//this.curSlots=[];
		//this.expandAll();
		this.addLib=true;
		this.newLib=false;
		this.groupSlots.forEach(data =>{
			this.expandedRows[data.CATEGORY] = true;
		})
		this.isExpanded=true
	}
	showLibs(doc?){//console.log(doc)
		this.checkLib();
		$('.nav-tabs a[href="#lib"]').tab('show');
		this.addLib=true;
		this.addedLibs=[];
		if(doc.libs&&doc.libs.length>0){
		for(let lib of doc.libs){
			this.addedLibs.push(lib.LIBRARY_ID);			
		}
		let libstring=this.addedLibs.join(',');
		//let updatedLibs=this.getLib(libstring);
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			let updatedLibs=data.RW_LIBRARY;
			if(this.selectedEditor=="F"){
				this.toFContentData('libs', updatedLibs, '')
			}else{
				this.toContentData('libs', updatedLibs, '')
			}
			//return updatedLibs;
		})
		//this.toContentData('libs', updatedLibs, '')
		
		}
	}
	showSelSlots(){
		$('.nav-tabs a[href="#slot"]').tab('show');
		this.slotGroup='S';
	}
	showSelLibs(){
		//console.log(this.contents)
		//console.log(this.getContentData('data'))
		this.addedLib=[];
		let libs=this.getContentData('data').rows[this.selectedCell.row][this.selectedCell.col].choice;//console.log(libs)
		if(libs&&libs.length>0){
			for(let lib of libs){
				if(lib.LIBRARY_ID&&lib.LIBRARY_ID.length>0){
					this.addedLib.push(lib)
				}
			}
		}
		//console.log(this.addedLib)
	}
	setCol(){
		if(this.colNo>0){
			let width=Math.round((96/this.colNo)*100)/100;
			this.curTableData.cols=[];
			for(let i=0; i<this.colNo; i++){
				let item:any
				if(this.isEven){
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':width, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['text']=item.NAME;
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml('Header'+i);
				}else{
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':'', 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['text']=item.NAME;
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml('Header'+i);
				}
				this.curTableData.cols.push(item)
			}			
		}
	}	
	clearChoice(){
		this.toContentData('', [], '');
		this.resetLib();
		this.selectedSlot=[];			
	}
	addPdfs(e,i){
		let info={'CATEGORY': "ERIS Data",'CONTENT': "",'KEY': "",'LABEL': "",'SHORT_CONTENT': "",'TYPE': "PDF", 'selectedfile':true}; //console.log(info)
		if(this.appendices.SUB_SECTIONS[i].RF){
			this.appendices.SUB_SECTIONS[i].RF.push(info);
		}else{
			this.appendices.SUB_SECTIONS[i].RF=[];
			this.appendices.SUB_SECTIONS[i].RF.push(info);
		}
	}
	addPdf(e,i, j){
		let info=this.pdfSlots[e]; //console.log(info)
		this.appendices.SUB_SECTIONS[i].RF[j]=info;		
	}
	removePdf(i, j){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				this.appendices.SUB_SECTIONS[i].RF.splice(j, 1);
			}
		})
	}
	selUp(index){//console.log(index);
		//this.newSlotOps
		moveItemInArray(this.newSlotOps, index-1, index);
			//this.array_move(this.newSlotOps,index-1, index )
		
	}
	selDown(index){//console.log(index);
		moveItemInArray(this.newSlotOps, index+1, index);
			//this.array_move(this.newSlotOps,index+1, index )
		
	}
	selRemove(index){//console.log(index);
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		this.newSlotOps.splice(index, 1);
		}
	})
	}
	setTextType(e){
		let data=$(e.target).prop('checked');//console.log(data);
		this.toContentData('intro', data, '');		
	}
	deleteFile(item, type){
		//console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					//console.log(JSON.parse(response))
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.uploadedFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); //console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
						this.throwError(JSON.parse(response));	
					}
				})
			}
		})
	}
	updateFile(item, type, e? ){//console.log(item);
		let data=$(e.target).prev('textarea').val();//console.log(data);
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		//console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			//console.log(response)
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(file);
				return										
			}
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		})
	}
	copyTemp(id){
		
	}
	addSec(sec){//console.log(sec);
		let newsec=JSON.parse(JSON.stringify(sec));
		if(newsec.SECTION_TITLE=='COST TABLES'){
			this.selectedCell=null;
			this.addPCATable();
		}else{
			newsec['id']=Utils.uniqueIdGenerator();
			for(let subSec1 of newsec.SUB_SECTIONS){
				subSec1['id']=Utils.uniqueIdGenerator();
				for(let subSec2 of subSec1.SUB_SECTIONS){
					subSec2['id']=Utils.uniqueIdGenerator();			
				}
			}
			this.contents.push(newsec); //console.log(this.contents)
			this.generateSeq();
		}
	}
	getPCAData(){
		if(this.currencies.length==0){
			let inputJson={"PROCEDURE":"getcurrency"};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				////console.log(data.RW_CURRENCYS)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data);
					return										
				}
				this.currencies=data.RW_CURRENCYS; //console.log(this.currencies)
			})
		
		let inputJson1={"PROCEDURE":"getPCACostTableMultipler","USER_ID":parseInt(this.userId)};
		//console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response);
				return										
			}
			this.multipliers=response.PCA_COST_MULTIPLIER;
		})
		let inputJson2={"PROCEDURE":"gettemplatepca","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID}
		//console.log(inputJson2);
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(response => {
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response);
				return										
			}
			if(response.PCA_DATA.length>0){
				this.pcaOp=JSON.parse(response.PCA_DATA); //console.log(this.pcaOp);
			}
		})
		}
	}
	addCost(type){
		this.checkPca();
		if(this.hasPca){
			if(type=='A'){
				this.addCostTable()
			}else if(type=='B'){
				this.addCostTable2()
			}
		}
	}
	addCostTable(){
		let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
		this.addToContent(item);
		//console.log(this.curIndex);
		this.setCurIndex();
		this.createCostTable();
	}
	addCostTable2(){
		let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
		this.addToContent(item);
		//console.log(this.curIndex);
		this.setCurIndex();
		this.createCostTable('cost2');
	}
	addPCATable(){
		let index=this.contents.findIndex(sec=>sec.TYPE=='COST');
		if (index>-1){
				Swal.fire({
					icon:'info',
					text: 'ONLY one PCA section allowed.',
				})	
			return
		}
		let uid=Utils.uniqueIdGenerator();
		let item={'TYPE':'COST','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "COST TABLES",'SUB_SECTIONS':[], 'id':uid};
		if(this.curIndex[0]>-1){
			this.contents.splice(this.curIndex[0]+1,0, item);
			this.curIndex=[this.curIndex[0]+1, this.addon, this.addon];
		}else{
			this.contents.push(item);
			this.curIndex=[this.contents.length-1, this.addon, this.addon];
		}
		this.generateSeq();	
		this.curIndex=[this.curIndex[0], this.addon, this.addon];
		this.addPCATable2();
		this.curIndex=[this.curIndex[0], this.addon, this.addon]
		let title="Immediate and Short Term Repair Cost Table";
		if(this.pcaOp.term=='Exclude'){
			title="Immediate Repair cost Table";
		}
		let item1={'TYPE':'PCATABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': title,'SUB_SECTIONS':[],"NEW":false};
		this.addToContent(item1);
		this.setCurIndex();
		this.createCostTable('pca');
	}
	addPCATable2(){
		let item={'TYPE':'PCATABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Replacement Repair Cost Table",'SUB_SECTIONS':[],"NEW":false};
		this.addToContent(item);
		//console.log(this.curIndex);
		this.setCurIndex();
		this.createCostTable('repair');		
	}
	createCostTable(type?){
		this.curCostTable={'cols':[],'rows':[]};
		let cols:any;
		let keys=[];
		if(type&&type=='repair'){
			cols=this.repairCols; //['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
			keys=this.repairKeys;//['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
		}else if(type&&type=='cost2'){
			cols=this.costCols2; //['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
			keys=this.costKeys2;//['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
			this.curCostTable['version']='2';
		}else{
			cols=this.costCols1;//['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Short Term Total'];
			//cols.splice(7,0,'Immediate Total');
			keys=this.costKeys1;//['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short']
			
		}
			for(let i=0; i<cols.length; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':cols[i],'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left','KEY':keys[i]};
				if(!type){
					if(item.KEY=='Cycle'||item.KEY=='Percent'){
						item['hide']=true;
					}
				}else if(type&&type=='pca'){
					if(item.KEY=='Reserve'){
						item['hide']=true;
					}
				}
				//console.log(item);
				this.curCostTable.cols.push(item)
			}
			let row=[]
			for(let j=0; j<this.curCostTable.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':'', 'KEY':''};
				item.COLUMNINTERNALNAME=this.curCostTable.cols[j].INTERNALNAME;
				if(!type){
					if(this.curCostTable.cols[j].KEY=='Cycle'||this.curCostTable.cols[j].KEY=='Percent'){
						item['hide']=true;
					}
				}else if(type&&type=='pca'){
					if(this.curCostTable.cols[j].KEY=='Reserve'){
						item['hide']=true;
					}
				}
				//console.log(item);
				row.push(item);
			}
			this.curCostTable.rows.push(row);
			//console.log(this.curCostTable)
			this.toContentData('data', this.curCostTable, '')
			let table={'data':this.curCostTable, 'index':this.curIndex};
			this.costTables.push(table);//console.log(this.costTables);
			
	}
	setCurIndex(){
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.curIndex=[index1,index2,index3+1];
		}else if(index2>-1&&!index3){
			this.curIndex=[index1,index2,0];			
		}else if(index1>-1&&!index2&&!index3){
			this.curIndex=[index1,0,this.addon];			
		}
	}
	selCost(item){//console.log(item)
		let index=this.curCostId.indexOf(item.COST_LIBRARY_ID);//console.log(index)
		if(index>-1){
			this.curCost.splice(index,1);
			this.curCostId.splice(index,1);
		}else{
			this.curCost.push(item);
			this.curCostId.push(item.COST_LIBRARY_ID);
		}
		//console.log(this.curCost)
		//console.log(this.curCostId)
				
	}
	addSelCost(){
		if(this.curCost.length>0){
			for(let item of this.curCost){
				let index=this.addedCost.findIndex(lib=>lib.COST_LIBRARY_ID==item.COST_LIBRARY_ID);
				if(index==-1){
					this.addedCost.push(item);
				}
			}
			this.curCost=[];
			this.curCostId=[];	
		}
		
	}
	addLibToCost(){
		this.toContentData('libs', this.addedCost, 'costLibModal');
		this.addedCost=[];	
		this.selectedRow=-1;
		this.selectedCell=null;
	}
	rmvAddedCost(){
		for(let item of this.curCost){
			let index=this.addedCost.findIndex(lib=>lib.COST_LIBRARY_ID==item.COST_LIBRARY_ID);
			if(index>-1){
				this.addedCost.splice(index,1);
			}
		}
		this.curCost=[];
		this.curCostId=[];
	}
	clearAddedCost(){
		this.addedCost=[];
		this.curCost=[];
		this.curCostId=[];
	}
	setCostTableTitle(){
		//console.log(this.pcaOp.term);
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){
				//console.log(sec);
				let index=sec.SUB_SECTIONS[0].data.cols.findIndex(col=>col.NAME=='Short Term Total');									
				if(this.pcaOp.term=='Exclude'){
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate Repair cost Table";
					sec.SUB_SECTIONS[0].data.cols[index].hide='Y';
					for(let row of sec.SUB_SECTIONS[0].data.rows){
						row[index].hide='Y';							
					}
				}else{
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate and Short Term Repair Cost Table";
					sec.SUB_SECTIONS[0].data.cols[index].hide='N';
					for(let row of sec.SUB_SECTIONS[0].data.rows){
						row[index].hide='N';							
					}
				}
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						//console.log(sec1);
						let index=sec1.data.cols.findIndex(col=>col.NAME=='Short Term Total');
						if(this.pcaOp.term=='Exclude'){
							sec1.data.cols[index].hide='Y';
							for(let row of sec1.data.rows){
								row[index].hide='Y';							
							}
						}else{
							sec1.data.cols[index].hide='N';
							for(let row of sec1.data.rows){
								row[index].hide='N';							
							}
						}
					}else{
						if(sec1.SUB_SECTIONS){
							for(let sec2 of sec1.SUB_SECTIONS){
								if(sec2.TYPE=='COSTTABLE'){
									let index=sec2.data.cols.findIndex(col=>col.NAME=='Short Term Total');
									if(this.pcaOp.term=='Exclude'){
										sec2.data.cols[index].hide='Y';
										for(let row of sec2.data.rows){
											row[index].hide='Y';								
										}
									}else{
										sec2.data.cols[index].hide='N';
										for(let row of sec2.data.rows){
											row[index].hide='N';								
										}
									}
								}
				
							}
						}
					}
				}
			}
		}
				
	}
	expanded=false;
	allTemplates=[];
	getCompanyTemplates(){
		let inputJson= {"PROCEDURE":"getcompanytemplates","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('companyTemplates',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			this.allTemplates=data.RW_TEMPLATES;
			for(let i=0; i<this.allTemplates.length;i++){
				//console.log(this.allTemplates[i].TEMPLATE_TYPE[0], i);
					this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.CATEGORY_NAME
					this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.SUBCATEGORY_NAME
				

			}
		})

	}
	expandcollapse() {
		if(this.allTemplates.length==0){
			this.getCompanyTemplates();
			this.getTemplateCounts();
			this.getTemplateTypeCategory();
		}
		this.expanded =! this.expanded;
		if(!this.expanded){
			//console.log($('#task-box'))
			$('#task-box').css('right', '360px');
			$('#task-box').css('transform', '');
		
		}else{
			$('#task-box').css('right', '5vw');
		}
	  }
	 
	  @ViewChild('iframe') iframe: ElementRef;
	   clickTemplate(){

		this.iframe.nativeElement.contentWindow.document.getElementById('templatebutton').click()

}
templateCounts;
templateCountDict ={};
templateFilterOptions=[];
templateFilterOptions2=[];
typeList2=[];
getTemplateCounts(){
let inputJson={"PROCEDURE":"gettemplatecounts","USER_ID":parseInt(this.userId)}
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
	//console.log("templateCounts",data);
	if (data.RESPONSE_STATUS=='N') {
		this.throwError(data);
		return										
	}
	this.templateCounts=data.TEMPLATE_COUNTS;
	this.templateFilterOptions.push(...data.TEMPLATE_COUNTS);
	//console.log("this.templateFilterOptions",this.templateFilterOptions)
	for(let template of this.templateCounts){
		this.templateCountDict[template.SUBCATEGORY_NAME]=template.TOTAL;
	}
});
}
selectedFilter2
filterTemplates(x){
this.tt.filter(x.SUBCATEGORY_NAME, 'SUBCATEGORY_NAME', 'contains')
}
selectedFilter3
filterTemplates3(x){
this.tt.filter(x, 'STATUS', 'contains')
}
filterTemplates2(x){
this.tt.filter(x.CATEGORY, 'CATEGORY_NAME', 'contains')
}
selectedFilter;
templateRow;
resetTypeList(){
this.typeList=[];
}
getTemplateHistory2(user){

let inputJson={"PROCEDURE":"gettemplatehistory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
	//console.log(data);
	if (data.RESPONSE_STATUS=='N') {
		this.throwError(data);
		return										
	}
	user.RW_TEMPLATE_HISTORY=data.RW_TEMPLATE_HISTORY;
});
}
@ViewChild('ttt') private tt: Table;
updateTemplateTitle(rowData){
let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":rowData.TEMPLATE_ID, "TEMPLATE_TITLE":rowData.TEMPLATE_TITLE};
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
	//console.log(data);
	if (data.RESPONSE_STATUS=='N') {
		this.throwError(data);
		return										
	}

})

}
changeStatus(user) {
//console.log(user)
let inputJson;
if(user.STATUS == "Active"){
	inputJson={"PROCEDURE":"removetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID}
}else{
	inputJson={"PROCEDURE":"activatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}

}

user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
//console.log(inputJson);
this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
	//console.log(data)
	  });

}
deleteTemplate(){
	let inputJson= {"PROCEDURE":"deletetemplate", "USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID};
	this.reportService.univeralService(JSON.stringify(inputJson))
	.subscribe(data => {
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data);
			return										
		}
		for(let i=0; i<this.allTemplates.length; i++){
			if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){	
				this.allTemplates.splice(i, 1);
				this.allTemplates = [].concat(this.allTemplates);
				}
		}
		//console.log(data);
	})
}
copyTemplate(include){
	let inputJson= {"PROCEDURE":"copytemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID,"INCLUDE_SLOT":include}
	this.reportService.univeralService(JSON.stringify(inputJson))
	.subscribe(data => {
		//console.log(data);
		if(data.RESPONSE_STATUS=="N"){
			this.throwError(data);
		
		}else if(data.RESPONSE_STATUS=="Y"){
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: data.MESSAGE,
				})
		}
		for(let i=0; i<this.allTemplates.length; i++){
			if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){
				this.allTemplates.splice(i, 0, data);
				this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].CATEGORY_NAME
				this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].SUBCATEGORY_NAME
		//		this.allTemplates = [].concat(this.allTemplates);
				break;
			}
		}
	})

}
	dismissConfirm2(event){
		$('#deleteModal').modal('hide');
	}
	dismissConfirm1(event){
		$('#deleteModal2').modal('hide');
	}
	dismissConfirm3(event){
		$('#deleteTempConfirm').modal('hide');
	}
	dismissConfirm4(event){
		$('#copyWith').modal('hide');
	}
	dismissConfirm(a){
		$(a).modal('hide');
	}	
	removeLib(item){//console.log(item);
		if(this.curCell){
			let index=this.curCell.libs.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.curCell.libs.splice(index, 1);			
			}
		}else if(this.selectedEditor=='F'){
			let data=this.getFContentData('libs'); //console.log(data);
			let index=data.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				data.splice(index, 1);
				this.addedLibs.splice(index, 1);
			
			}
			
		}else  if(this.selectedEditor=='O'){
			let data=this.getContentData('libs'); //console.log(data);
			let index=data.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				data.splice(index, 1);
				this.addedLibs.splice(index, 1);
			
			}
		}
	}
	ifSeq(e){
		let config=$(e.target).prop('checked'); //console.log(config)
		let data='Y';
		if(config){
			data='N';
		}
		this.toContentData('DISPLAY_SEQUENCE', data, ''); 
		this.generateSeq();
	}
	private getAllSlotId(str){//console.log(str)
		if(!str)return
		let indices1=this.getIndices(str,'data-id=');////console.log(indices1);
		let indices2=this.getIndices(str, 'data-type="text" data-status');////console.log(indices2);
		let ids=[];
		for(let i=0; i<indices1.length; i++){
			let text=str.substring(indices1[i],indices2[i]).split('"')[1]; ////console.log(text)
			let id=parseInt(text);
			if(ids.indexOf(id)==-1){
			ids.push(parseInt(text));
			}
		}
		//console.log(ids);
		return ids
	}
	private getIndices(str, substr){
		let indices=[];
		let index = str.indexOf(substr);
		while(index !== -1) {
			indices.push(index);
			index = str.indexOf(substr, index + 1);
		}
		////console.log(indices);
		return indices;
	}
	saveTimer:any;
	autoSave(){
		let that=this;
		//window.clearInterval(that.saveTimer);
		this.saveTimer = window.setInterval(function () {
			that.saveTemplate();		
		},  60000);
		
	}
	filterSlot(e){
		////console.log(e.target);
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}
		//console.log(key);
		let inputJson={"PROCEDURE":"searchslotsfortemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,"SLOT_KEYWORD":key};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
			}else{
				this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
			//this.slots=data.RW_SLOTS;
				if(!this.isExpanded){
				this.groupSlots.forEach(data =>{
					this.expandedRows[data.CATEGORY] = true;
				})
				this.isExpanded=true
				//console.log(this.expandedRows);
			}
		})
	}
	hasPca=false;
	checkPca(){
		let index=this.contents.findIndex(sec=>sec.TYPE=='COST');
		if(index>-1){
			this.hasPca=true;
		}else{
			this.hasPca=false;
		}
	}
	getLib(libstring){
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
			let updatedLibs=data.RW_LIBRARY;
			this.toContentData('libs', updatedLibs, '')
			return updatedLibs;
		})
	}
	refreshSlots(){
		this.getSlots();
	}
	refreshLibs(){
		this.getLibraries();
		this.getLibLabels();
	}
	getFrontIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.frontpages.length; i++){
			if(this.frontpages[i].id==id){
				secIndex=[i,this.addon];
				break;
			}else{
				if(this.frontpages[i].SUB_SECTIONS){
				for(let j=0; j<this.frontpages[i].SUB_SECTIONS.length; j++){
					if(this.frontpages[i].SUB_SECTIONS[j].id==id){
						secIndex=[i,j];									
						break;
					}
				}
				}
			}
		}
		if(secIndex.length>0){
			this.selectedEditor='F';
		}
		//console.log(secIndex);
		return secIndex;
	}
	getIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.contents.length; i++){
			if(this.contents[i].id==id){
				secIndex=[i,this.addon,this.addon];
				break;
			}else{
				for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
					if(this.contents[i].SUB_SECTIONS[j].id==id){
						secIndex=[i,j,this.addon];									
						break;
					}else{
						for(let k=0; k<this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length; k++){
							if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].id==id){
								secIndex=[i,j,k];
								break;
							}
						}
					}
				}
			}
		}
		//console.log(secIndex);
		return secIndex;
	}
	trackByFuntion(index, item) {
		return index;
	}
	getSftContent(data){
		if(data.CONTENT_HTML.length>0){
			data.htmltext=this.sanitizer.bypassSecurityTrustHtml(data.CONTENT_HTML);
		}
	
	}
	checkLib(){
		if(this.libraries.length==0){
			this.refreshLibs();
		}
	}
	uploadFile1(){
		this.uploading=true;
		let that=this;
		const files = this.file3.nativeElement.files; //console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for (let file of files){  //for multiple files
			const ext = file.name.replace(/.+\./, '');
		   if (this.acceptType.indexOf(ext) === -1) {
			   Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			   this.uploading=false;
			   return;
		   }
	   }
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.uploading=false;
						that.throwError(result);
					}else{
						that.uploading=false;
						that.newSlotFile.name=result.FILE_NAME;
						that.newSlotFile.url=result.FILE_URL;
						that.newSlotFile.ext=result.FILE_EXTENSION;//console.log(that.newSlotFile)
					}					
				})			
		}
		reader.readAsDataURL(file);
		} 
  }
  uploadPdf(){//console.log(this.selectIndex);
		this.uploading=true;
		let that=this;
		const files = this.file4.nativeElement.files; //console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for(let i=0; i<files.length; i++){
			const ext = files[i].name.replace(/.+\./, '');
			if (this.acceptType.indexOf(ext) === -1) {
				Swal.fire('Oops...', ext + ' file Type is not acceptable..');
				this.uploading=false;
				return;
			}
		}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.uploading=false;
						that.throwError(result);
					}else{//console.log(that.selectIndex);
						that.frontpages[that.selectIndex].pdf=result.FILE_URL;
						that.frontpages[that.selectIndex].pdfName=result.FILE_NAME;
						that.uploading=false;//console.log(that.frontpages);
					}					
				})			
		}
		reader.readAsDataURL(file);
		} 
  }
  editCell(doc, e, x, y){
		//console.log(doc, x, y);
		if(doc.TYPE!=='TABLE'||(doc.data.parent_table&&doc.data.parent_table.length>0)){
			return
		}
		this.cellShow=true;
		this.curSec=doc;
		this.selectedCell={'row':x,'col':y};
	}
	cellData(e, id?){//console.log(e)
		//console.log(this.selectedCell);
		this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
		//console.log('first',this.curIndex);
		this.selectedRow=-1;//this.selectedCell.row;
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		if(this.pageIndex[0]>-1){
			this.toFContentData('htmltext', e, '',this.pageIndex);
			this.toFContentData('', data, '', this.pageIndex);
		}else if(this.curIndex[0]>-1){
			this.toContentData('htmltext', e, '',this.curIndex);
			this.toContentData('', data, '', this.curIndex);
		}
		let ids=this.getAllSlotId(e); //console.log(ids);
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let index=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(index>-1){
					docSlot.push(this.slots[index]);
				}
			
		}
		//console.log(docSlot)
		if(docSlot.length>0){
			if(this.pageIndex[0]>-1){
				this.toFContentData('slots', docSlot, '', this.pageIndex);
			}else if(this.curIndex[0]>-1){
				this.toContentData('slots', docSlot, '', this.curIndex);
			}			
		}
	}	
  }
	toCell(id){
		this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
		let data:any;
		if(this.pageIndex[0]>-1){
			data=this.getFContentData('data'); //console.log(data);
		}else if(this.curIndex[0]>-1){
			data=this.getContentData('data'); //console.log(data);
		}
		if(this.allRow){
			for(let row of data.rows[this.selectedCell.row].items){
				row.bkcolor=this.curCell.bkcolor
			}
		}
		if(this.allCol){
			for(let row of data.rows){
				if(row.items[this.selectedCell.col]){
					row.items[this.selectedCell.col].bkcolor=this.curCell.bkcolor
				}
			}
		}
		this.cellShow=false;
		this.curCell=null; 
		/*this.autoSave();*/
	}
	selectCell(doc, i, col, cell){
		//console.log(doc);
		//console.log(i);
		//console.log(col);
		//console.log(cell);
		this.cellShow=true;
		this.curSec=doc;
		this.curCol=col;
		this.curCell=cell;
		this.allRow=false;
		this.allCol=false;
		let x=i;
		let y=doc.data.cols.findIndex(data=>data.INTERNALNAME==col.INTERNALNAME);
		this.selectedCell={'row':x,'col':y}; //console.log(this.selectedCell);
	
	}
	headerShow=false;
	colIndex=-1;
	selectCol(doc, i, col){
		//console.log(doc);
		//console.log(i);
		//console.log(col);		
		this.headerShow=true;
		this.curSec=doc;
		this.curCol=col;
		this.colIndex=i;
		/*this.curCell=cell;
		let x=i;
		let y=doc.data.cols.findIndex(data=>data.INTERNALNAME==col.INTERNALNAME);
		this.selectedCell={'row':x,'col':y}; //console.log(this.selectedCell);
		*/
	}
	colText(e){
		//console.log(this.curSec);
		if(e.length>0&&this.colIndex>-1){
			////console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			this.curSec.data.cols[this.colIndex].text=e;
		}
	}
	colData(e, id?){//console.log(e)
		//console.log(this.curSec);
		if(e.length>0&&this.colIndex>-1){
			this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
			//console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			this.curSec.data.cols[this.colIndex].NAME=e;
			this.curSec.data.cols[this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
		}
	
	}
	toCol(id){
		this.headerShow=false;
		if(this.autoFlag){
		this.autoSave();
	};
	}
   colReorder(e, id){
		//console.log(e.dragIndex);
		//console.log(e.dropIndex);
		//console.log(e.columns);// Columns array after reorder
		/*for(let i=0; i<e.columns.length; i++){
			let id='col'+i;
			e.columns[i].INTERNALNAME=id;
		}*/
		for(let row of this.curSec.data.rows){
			moveItemInArray(row.items, e.dragIndex, e.dropIndex);
			/*for(let j=0; j<row.items.length; j++){
				let id='col'+j;
				row.items[j].COLUMNINTERNALNAME=id;
			}*/
			
		}
   }
   rowReorder(e){//console.log(e);
	   //console.log(e.dragIndex);
		//console.log(e.dropIndex);
   }
   colResize(e, doc){////console.log(e);
	   ////console.log(e.element);
	   this.curSec=doc;
	   let ele=e.element;
	   let wi=ele.style.width; ////console.log(wi);
	    let pagewidth=816-parseInt(this.pageMargin.right)-parseInt(this.pageMargin.left);
	  
	   let items=$(ele).parent().children(); ////console.log(items);
	   for(let i=1; i<items.length; i++){
		   let cellWidth=items[i].offsetWidth; ////console.log(cellWidth)
		   this.curSec.data.cols[i-1].width=cellWidth;
		    let val=Math.round(cellWidth/pagewidth*100); //console.log(val)
		   this.curSec.data.cols[i-1].width=val;
		   this.curSec.data.cols[i-1].unit='%';
	   }
		
   }
   selectedrows=[];
   selectToggle(e, doc, index){//console.log(doc, index)
		e.stopPropagation();
		let selectedrows=[];
		if (e.ctrlKey) {
			doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
			for(let i=0; i<doc.data.rows.length; i++){
				if(doc.data.rows[i]['selected']){
					selectedrows.push(i);
				}
			}
			//console.log(selectedrows)
			if(selectedrows.length==1){
				this.selectedRow=selectedrows[0];
			}else{
				this.selectedRow=-1;
			}
			
		}else{
			for(let i=0; i<doc.data.rows.length; i++){
				if(i!=index){
					doc.data.rows[i]['selected']=false
				}else{
					doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];
					if(doc.data.rows[i]['selected']){
						this.selectedRow=index;
					}else{
						this.selectedRow=-1;
					}
				}
			}			
		}
		this.curSec=doc;
		//console.log(this.selectedRow)
		//console.log(doc);
   }
	deleteRows(doc){//console.log(doc)
	   	let totals=[];
		for(let i=0; i<doc.data.rows.length; i++){
			if(doc.data.rows[i].selected){
				totals.push(i); 
			}
		}
		let that=this;
		if(totals.length>0){
			Swal.fire({
				icon:'info',
				title: 'Are you sure you want to delete '+totals.length+' item(s)?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					doc.data.rows=doc.data.rows.filter(row => row.selected!=true);				
				}
			})
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to delete.',
			})
		}
   }
	addCSub(e){
		let posi=$(e.target).prev('select').val();//console.log(posi)
		let data=this.curSec.data;//this.getContentData('data'); //console.log(data);
		let rowData={'items':[]};
		let row=[{'COLUMNINTERNALNAME':data.cols[0].INTERNALNAME,'data':'', 'celAllign':posi, 'colspan':data.cols.length}];
		let key=data.cols[0].INTERNALNAME;
		rowData[key]='';
		rowData.items=row;
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
		}	
	}
	addCRows(e){
		let no=$(e.target).prevAll('input').val(); //console.log($(e.target).prev('input'));//console.log(no);
		if(no>0){
			let data=this.curSec.data;//this.getContentData('data'); //console.log(data);
			for(let i=0; i<no; i++){
				let row=[];
				let rowData={'items':[]};
				for(let j=0; j<data.cols.length; j++){
					let item={'COLUMNINTERNALNAME':'','data':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					rowData[data.cols[j].INTERNALNAME]='';
					//console.log(item)
					row.push(item);
				}
				rowData.items=row;
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
				}else{
					data.rows.push(rowData);
				}
				
			}
		}
	}
	hideRows(doc){
		for(let row of doc.data.rows){
			if(row.selected){
				row['hide']=!row['hide']; 
				//row.selected=false;
			}
		}
	}
	resetProp(doc){
		if(doc.TYPE=='TABLE'&&(!doc.erisName)&&(!this.cellShow)){
			this.curSec=doc;
			this.curCell=null;
			for(let row of doc.data.rows){
				row.selected=false;
			}
		}
		this.selectedRow=-1;
	}
	addToIden(label, id){
		let ele='#'+id;
		let text=$(ele).val();//console.log(text);
		if(text.length>0){
			text=text+'; '+label;
		}else{
			text=label;
		}
		$(ele).val(text);		
	}
	pageData(e, index, index1?){
		//console.log('page', e, index); 
		this.curIndex=[this.addon,this.addon,this.addon];
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['text']=e;
			this.frontpages[index].SUB_SECTIONS[index1]['htmltext']=data;
		}else{
			this.frontpages[index]['text']=e;
			this.frontpages[index]['htmltext']=data;
		}
		let ids=this.getAllSlotId(e); //console.log(ids);
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let sindex=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(sindex>-1){
					docSlot.push(this.slots[sindex]);
				}
			
			}		
		}
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['slots']=docSlot;
		}else{
			this.frontpages[index]['slots']=docSlot;
		}	
		if(this.autoFlag){
			this.autoSave();
		};
	}
	/*pageData(e, index){
		//console.log('page', e, index); 
		this.curIndex=[this.addon,this.addon,this.addon];
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		this.frontpages[index]['text']=e;
		this.frontpages[index]['htmltext']=data;
		let ids=this.getAllSlotId(e); //console.log(ids);
	
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let index=this.slots.findIndex(slot=>slot.SLOT_ID==id);
				if(index>-1){
					docSlot.push(this.slots[index]);
				}
			
			}		
		}
		this.frontpages[index]['slots']=docSlot;
		if(this.autoFlag){
			this.autoSave();
		};
	}*/
	removePage(s){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				that.frontpages.splice(s, 1);		
			}	
		})			
	}
	changeSrc(e, page, src){
		if($(e.target).prop('checked')){
			page['pageSrc']=src;
		}else{
			page['pageSrc']='letter_style';
		}
	}
	showPages(){
		//console.log(this.frontpages)
	}
	
	pdfFname={"text":'<p><span class="placeholder" data-id="1" data-type="text" data-status="N">{Project Number/Name}</span>-<span class="placeholder" data-id="8" data-type="text" data-status="N">{Property Address}</span></p>',
	'reqIndex':0, "name":''};
	pdfData(e){
		//console.log(e)
		this.pdfFname.text=e;
		//this.pdfFname.htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
	}
	pdfPara(e){
		//console.log(e);
		if(e.length>0){
			this.pdfFname.name=e;
		}
	}
	savepdf(){
		this.pdfFname.reqIndex++;
	}
	sideNavWidth = '60px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '60px'
			this.toggleSideBarVar = false
		}
	}
	openHFPage(id){
		let inputJson={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);					
			}else{console.log(data)
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(htData.inputType&&htData.inputType=='HTML'){
						let dataInput=htData.inputType;
 						let savedHTML=this.sanitizer.bypassSecurityTrustHtml(htData.text); 
					
					//this.titleService.setTitle("Footer"+' - ');
					//this.location.go('/cover/Footer-'+data.HEADERFOOTER_ID.toString());
					let newWin = window.open('',data.HF_TITLE);
					newWin.document.write(htData.text);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
				}				
			}
		})		
	}
	openCoverPage(id){
		let inputJson={"PROCEDURE":"getcoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);					
			}else{console.log(response)
				let data=JSON.parse(response.COVERPAGE_DATA);
				if(data.html&&data.html.length>0){
					let newWin = window.open('',response.HF_TITLE);
					newWin.document.write(data.html);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
			}			
		})		
	}
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			//console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }

}
